import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const FLAGS = {
  pt: (
    <img src="/flags/br-icon.jpeg" alt="Português" width="28" height="20" style={{ borderRadius: '4px' }} />
  ),
  en: (
    <img src="/flags/eua-icon.jpeg" alt="English" width="28" height="20" style={{ borderRadius: '4px' }} />
  ),
};

const resources = {
  pt: {
    translation: {

      // ── Navbar ──────────────────────────────────────────────────────────────
      nav: {
        home: 'Início',
        howItWorks: 'Como Funciona',
        whyPreserve: 'Por que preservar?',
        explore: 'Explorar',
        createMemorial: 'Criar Memorial',
        login: 'Entrar',
        myAccount: 'Minha Conta',
        myMemorials: 'Meus Memoriais',
        myPurchases: 'Minhas Compras',
        support: 'Suporte',
        admin: 'Admin',
        logout: 'Sair',
        supporterPanel: 'Painel do affiliate',
        myAccountSection: 'Minha conta',
        closeMenu: 'Fechar menu',
        openMenu: 'Abrir menu',
        toggleLanguage: 'Trocar idioma',
      },

      // ── Auth ─────────────────────────────────────────────────────────────────
      auth: {
        signIn: 'Entrar',
        signUp: 'Cadastrar',
        email: 'Email',
        password: 'Senha',
        name: 'Nome',
        continueWithGoogle: 'Continuar com Google',
        alreadyHaveAccount: 'Já tem uma conta?',
        dontHaveAccount: 'Não tem uma conta?',
      },

      // ── Home — Hero ──────────────────────────────────────────────────────────
      hero: {
        title: 'Transforme lembranças\nem homenagens.',
        description: 'Mantenha as histórias de quem você ama vivas, acessível a qualquer momento, de qualquer lugar.',
        cta: 'Criar memorial gratuito',
        ctaSecondary: 'Por que preservar memórias?',
      },

      // ── Home — Como Funciona ─────────────────────────────────────────────────
      howItWorks: {
        eyebrow: 'Como Funciona',
        title: 'Em apenas 3 passos simples,\ncrie uma homenagem eterna.',
        description: 'Do início ao memorial publicado, tudo pensado para ser simples, bonito e significativo.',
        footer: 'Criar o memorial é gratuito · Você só paga se quiser publicar',
        step: 'Passo',
        steps: [
          {
            num: '01',
            label: 'Crie o memorial',
            title: 'Crie o memorial',
            subtitle: 'Como preencher?',
            description: 'Preencha as informações da homenagem: dados pessoais, uma frase especial, biografia, fotos e até um áudio. Tudo de forma simples e carinhosa.',
            cta: 'Começar agora',
          },
          {
            num: '02',
            label: 'Veja o resultado',
            title: 'Veja o resultado',
            subtitle: 'Como fica o memorial?',
            description: 'O memorial é exibido pronto na tela para você ver como ficou. Ele fica salvo no seu perfil, pronto para ser publicado quando você decidir.',
            cta: 'Ver exemplo',
          },
          {
            num: '03',
            label: 'Escolha um plano',
            title: 'Escolha um plano',
            subtitle: 'Como publicar?',
            description: 'Se gostar do resultado, escolha um plano para publicar o memorial online e/ou receber a placa física com QR Code para o túmulo.',
            cta: 'Ver planos',
          },
        ],
      },

      // ── Home — Planos ────────────────────────────────────────────────────────
      plans: {
        eyebrow: 'Planos',
        title: 'Escolha seu Plano',
        description: 'Duas opções para eternizar a memória de quem você ama',
        choosePlan: 'ESCOLHER PLANO',
        digital: 'Plano Digital',
        digitalPrice: 'R$ 29,90',
        digitalDesc: 'Memorial digital publicado na plataforma',
        digitalFeatures: [
          'Memorial digital completo',
          'Galeria de até 10 fotos',
          'Áudio de homenagem',
          'QR Code digital',
        ],
        plaque: 'Plano Placa QR Code',
        plaquePrice: 'R$ 149,90',
        plaqueDesc: 'Memorial + Placa física de aço inox',
        plaqueFeatures: [
          'Tudo do Plano Digital',
          'Placa física em aço inox',
          'QR Code gravado permanente',
          'Envio para todo Brasil',
        ],
        mostPopular: 'Mais Popular',
        complete: 'Plano Completo',
        completeDesc: 'Memorial + Placa física',
        editFee: 'Taxa de edição futura',
        paymentSafe: 'Pagamento seguro via',
      },

      // ── Home — Product Showcase ──────────────────────────────────────────────
      showcase: {
        eyebrow: 'Produto físico',
        title: 'Veja como sua homenagem\nganha vida',
        description: 'Após contar a história do seu ente querido, criamos uma homenagem física única — feita com cuidado para eternizar memórias.',
        badge1: 'Aço inox gravado',
        badge2: 'QR Code',
        mainLabel: 'Foto do produto final',
        card1: 'Detalhe do acabamento',
        card2: 'Como ele chega embalado',
        card3: 'Exemplo de homenagem pronta',
        benefit1Title: 'Produzido com cuidado e respeito',
        benefit1Desc: 'Cada peça é feita com atenção ao detalhe e ao que ela representa.',
        benefit2Title: 'Material de alta qualidade',
        benefit2Desc: 'Aço inox resistente ao tempo, preservando a memória por décadas.',
        benefit3Title: 'Uma lembrança eterna para a família',
        benefit3Desc: 'Um ponto de encontro físico para homenagear e lembrar quem partiu.',
        cta: 'Começar minha homenagem',
        ctaFooter: 'Criar é gratuito · Salve como rascunho e complete no seu tempo · Você só paga ao publicar',
        imgSoon: 'Foto do produto real em breve',
        imgInsert: 'Inserir foto aqui',
        products: [
          {
            name: 'Gravado para durar para sempre',
            subtitle: 'Aço inox com laser de precisão',
          },
          {
            name: 'Cada detalhe conta uma história',
            subtitle: 'Acabamento premium, feito com cuidado',
          },
          {
            name: 'Pronto para emocionar',
            subtitle: 'Entregue com amor, do jeito certo',
          },
        ],
      },

      // ── Home — Trust Badges ──────────────────────────────────────────────────
      trust: {
        secure: 'Site Seguro',
        payment: 'Compra pelo Mercado Pago',
        delivery: 'Entrega Rastreável',
      },

      // ── Home — FAQ ───────────────────────────────────────────────────────────
      faq: {
        eyebrow: 'FAQ',
        title: 'Todas as respostas.',
        description: 'Tem uma dúvida? A resposta está aqui.',
        items: [
          {
            q: 'Como funciona o QR Code?',
            a: 'O QR Code é gravado em uma placa de aço inox durável. Quando escaneado com um smartphone, ele direciona automaticamente para o memorial digital da pessoa homenageada.',
          },
          {
            q: 'O memorial fica disponível para sempre?',
            a: 'Sim! Após a criação e pagamento, seu memorial fica hospedado permanentemente em nossa plataforma, acessível 24/7 de qualquer lugar do mundo.',
          },
          {
            q: 'Posso editar o memorial depois de criado?',
            a: "Sim! Após adquirir um plano, você pode editar seu documento gratuitamente e a qualquer momento. Basta acessar a página 'Meus Memoriais' e clicar no botão de edição disponível no card do memorial.",
          },
          {
            q: 'Quanto tempo demora a entrega da placa?',
            a: 'A produção e envio levam de 7 a 15 dias úteis. Você receberá código de rastreamento assim que o pedido for despachado.',
          },
          {
            q: 'A placa resiste às condições do tempo?',
            a: 'Sim! Nossa placa é feita em aço inox de alta qualidade, resistente à chuva, sol e variações de temperatura, garantindo durabilidade por muitos anos.',
          },
        ],
      },

      // ── Home — Depoimentos ───────────────────────────────────────────────────
      testimonials: {
        eyebrow: 'Avaliações',
        title: 'O que nossos clientes dizem',
        close: 'Fechar',
        review: 'Avaliar',
        client: 'Cliente',
        prev: 'Anterior',
        next: 'Próximo',
        review_n: 'Avaliação {{n}}',
      },

      // ── Home — Why Choose Us ─────────────────────────────────────────────────
      why: {
        eyebrow: 'Por que nos escolher',
        title: 'Por que a\nRemember QRCode.',
        description: 'Escolha quem entende a importância de preservar memórias. Oferecemos uma tecnologia única de QR Codes personalizados, que conecta o presente ao passado de forma significativa.',
        cta: 'Sobre a Remember QRCode',
      },

      // ── Memorial ─────────────────────────────────────────────────────────────
      memorial: {
        createTitle: 'Criar Memorial',
        step1: 'Dados da Pessoa',
        step2: 'Conteúdo do Memorial',
        step3: 'Dados do Responsável',
        fullName: 'Nome Completo',
        relationship: 'Parentesco',
        birthCity: 'Cidade de Nascimento',
        birthState: 'Estado de Nascimento',
        deathCity: 'Cidade de Falecimento',
        deathState: 'Estado de Falecimento',
        photo: 'Foto Principal',
        publicMemorial: 'Exibir no explorar',
        mainPhrase: 'Frase Principal',
        biography: 'Biografia',
        gallery: 'Galeria de Fotos',
        audio: 'Áudio',
        audioDetail: 'Opcional',
        responsibleName: 'Nome do Responsável',
        phone: 'Telefone',
        next: 'Próximo',
        back: 'Voltar',
        finish: 'Finalizar',
        selectPlan: 'Selecionar Plano',
        notFound: 'Memorial não encontrado',
        notFoundDesc: 'Este memorial pode ter sido removido ou o link está incorreto. Verifique o endereço e tente novamente.',
        exploreBtn: 'Explorar memoriais',
        loading: 'Carregando memorial…',
        birthDate: 'Data de Nascimento',
        deathDate: 'Data de Falecimento',
        birthState: 'Estado',
        deathState: 'Estado',
        stepLabel: 'Etapa {{step}} de 3',
        heroEyebrow: 'Uma homenagem eterna',
        step1Label: 'Dados',
        step2Label: 'Conteúdo',
        step3Label: 'Responsável',
        photoReady: 'Foto recortada e pronta',
        photoChange: 'Trocar foto',
        photoRemove: 'Remover',
        photoTap: 'Toque para enviar uma foto',
        photoCrop: 'Você poderá recortar após selecionar',
        galleryTap: 'Toque para adicionar fotos ({{count}}/10)',
        audioTap: 'Toque para enviar um áudio',
        privacyNote: 'Suas informações são tratadas com total privacidade e usadas apenas para contato sobre o memorial.',
        saving: 'Salvando...',
        processing: 'Processando...',
        relationshipPlaceholder: 'Ex: Pai, Mãe, Avô, Amigo...',
        mainPhrasePlaceholder: 'Uma frase especial para homenagear...',
        biographyPlaceholder: 'Conte a história de vida, momentos especiais, características marcantes...',
        galleryCount: 'Até 10 fotos',
        inMemoryOf: 'Em memória de',
        lifeStory: 'História de Vida',
        noStory: 'Nenhuma história cadastrada.',
        noPhotos: 'Nenhuma foto na galeria',
        tributeMessage: 'Mensagem de Homenagem',
        noAudio: 'Nenhum áudio cadastrado',
        createdWithLove: 'Criado com amor por {{name}}',
        tab_historia: 'História',
        tab_memorias: 'Memórias',
        tab_audio: 'Áudio',
        tab_condolencias: 'Condolências',
      },

      selectPlan: {
        eyebrow: 'Publicar memorial',
        title: 'Escolha seu Plano',
        description: 'Selecione o plano ideal para eternizar as memórias',
        affiliateLabel: 'Tem um código de affiliate?',
        affiliatePlaceholder: 'Ex: JOAO2024',
        applyBtn: 'Aplicar',
        codeApplied: 'Código {{code}} aplicado',
        codeDiscount: '{{pct}}% de desconto no plano escolhido',
        recommended: 'Recomendado',
        oneTimePayment: 'Pagamento único',
        selectBtn: 'Selecionar Plano',
        processing: 'Processando...',
        plans: [
          {
            id: 'digital',
            name: 'Plano Digital',
            price: 29.90,
            features: [
              'Memorial digital completo',
              'Galeria de até 10 fotos',
              'Áudio de homenagem',
              'QR Code digital',
              'Publicação instantânea',
              'Hospedagem eterna',
            ],
          },
          {
            id: 'plaque',
            name: 'Plano Placa QR Code',
            price: 149.90,
            features: [
              'Tudo do Plano Digital',
              'Placa física em aço inox',
              'QR Code gravado permanente',
              'Envio para todo Brasil',
              'Suporte prioritário',
              'Rastreamento de entrega',
            ],
          },
        ],
      },

      condolences: {
        title: 'Condolências',
        thankYou: 'Sua mensagem foi enviada. Obrigado por homenagear',
        viewMessages: 'Ver mensagens',
        sendCondolence: 'Enviar condolência',
        noMessages: 'Nenhuma mensagem ainda',
        beFirst: 'Seja o primeiro a deixar uma homenagem para {{name}}.',
        step1: '1 · Escolha ou escreva sua mensagem',
        step2: '2 · Quem está enviando?',
        sendAnonymous: 'Enviar como anônimo',
        anonymousDesc: 'Sua identidade não será exibida',
        yourName: 'Seu nome',
        yourNamePlaceholder: 'Como você se chama?',
        youAre: 'Você é (opcional)',
        minChars: '{{count}} / mín. 10 caracteres',
        sending: 'Enviando...',
        sendBtn: 'Enviar minha condolência',
        writeMessage: 'Escreva sua mensagem de coração...',
        anonymous: 'Anônimo',
        showLess: 'Ver menos ↑',
        showMore: 'Ver mais ↓',
        relations: {
          familia: 'Familiar',
          amigo: 'Amigo(a)',
          colega: 'Colega',
          vizinho: 'Vizinho(a)',
          outro: 'Outro',
        },
        presets: [
          { short: 'Paz e conforto', text: 'Que a paz e o conforto estejam com vocês neste momento tão difícil. Estamos em pensamento e orações.' },
          { short: 'Saudade com amor', text: 'Que a saudade seja sempre uma forma de amor. Guardarei com carinho cada memória ao lado dessa pessoa especial.' },
          { short: 'Força e fé', text: 'Que Deus console seus corações e que a lembrança dos momentos felizes traga luz nos dias mais sombrios.' },
          { short: 'Vida eterna', text: 'Uma vida tão especial deixa marcas eternas em todos que tiveram o privilégio de conhecê-la. Que descanse em paz.' },
          { short: 'Sempre conosco', text: 'Quem parte com bondade no coração nunca desaparece de verdade — vive em cada sorriso e em cada lembrança.' },
          { short: 'Minha própria mensagem', text: '' },
        ],
      },

      review: {
        loginRequired: 'Faça login para deixar sua avaliação',
        successTitle: 'Avaliação enviada com sucesso!',
        successDesc: 'Obrigado pelo seu feedback. Sua avaliação será revisada e publicada em breve.',
        eyebrow: 'Avaliação',
        title: 'Deixe sua Avaliação',
        ratingLabel: 'Sua nota *',
        titleLabel: 'Título (opcional)',
        titlePlaceholder: 'Ex: Excelente serviço!',
        commentLabel: 'Comentário (opcional)',
        commentPlaceholder: 'Conte sua experiência com a plataforma...',
        sending: 'Enviando...',
        sendBtn: 'Enviar Avaliação',
        ratings: { 1: 'Ruim', 2: 'Regular', 3: 'Bom', 4: 'Muito bom!', 5: 'Excelente!' },
      },

      qrModal: {
        titlePrint: 'QR Code para Impressão',
        titleDefault: 'QR Code do Memorial',
        formatPng: 'PNG (alta resolução)',
        formatPdf: 'PDF (5×5cm — gráfica)',
        formatSvg: 'SVG (vetorizado)',
        infoPng: '🖨️ <strong>{{size}}×{{size}}px</strong> — pronto para gravação 5×5cm',
        infoPdf: '📄 <strong>PDF 50×50mm</strong> — pronto para enviar à gráfica',
        infoSvg: '📐 <strong>SVG vetorizado</strong> — escala infinita, ideal para gráfica',
        infoPreview: '🔍 Preview — admin baixa em alta resolução (1200px)',
        copy: 'Copiar link',
        copied: 'Copiado!',
        downloadPng: 'Baixar PNG (1200px)',
        downloadPngDefault: 'Baixar PNG',
        downloadPdf: 'Baixar PDF (50×50mm)',
        downloadSvg: 'Baixar SVG (gráfica)',
        plateLabel: 'Uma vida, muitas memórias.',
      },

      // ── Footer ───────────────────────────────────────────────────────────────
      footer: {
        tagline: 'Memoriais digitais para preservar histórias e homenagear vidas.',
        followUs: 'Siga-nos',
        colProduct: 'Produto',
        colCompany: 'Empresa',
        colSupport: 'Suporte',
        colGuarantees: 'Garantias',
        emailLabel: 'E-mail',
        chatLabel: 'Chat',
        chatLink: 'Falar no WhatsApp',
        guarantee1: 'Compra Segura',
        guarantee2: 'Entrega Rastreável',
        guarantee3: 'Suporte Dedicado',
        copyright: '© {{year}} Remember QRCode · Todos os direitos reservados.',
        about: 'Sobre a Remember QRCode',
        responsibility: 'Política de Responsabilidade',
        privacy: 'Política de Privacidade',
        returns: 'Troca, Devolução e Reembolso',
        terms: 'Termos e Condições',
        delivery: 'Política de Entrega',
        aboutShort: 'Sobre nós',
        privacyShort: 'Privacidade',
        cancellation: 'Cancelamento e Reembolso',
      },

      // ── Security Badge ───────────────────────────────────────────────────────
      security: {
        secure: 'Compra 100% segura',
        redirectMessage: 'Você será redirecionado para o pagamento seguro via',
        paymentSafe: 'Pagamento seguro via',
        secureEnv: 'Ambiente seguro',
        ssl: 'SSL 256-bit',
        paymentVia: 'Pagamento via',
      },

      // ── Payment ──────────────────────────────────────────────────────────────
      payment: {
        eyebrow: 'Pagamento',
        title: 'Finalize seu Pagamento',
        subtitle: 'Escaneie o QR Code do Pix para pagar',
        qrUnavailable: 'QR Code não disponível',
        instructionsLabel: 'Instruções',
        instructions: [
          'Abra o aplicativo do seu banco',
          'Escolha a opção Pix',
          'Escaneie o QR Code acima',
          'Confirme o pagamento',
        ],
        waitingConfirmation: 'Aguardando confirmação do pagamento...',
      },

      // ── Payment Success ──────────────────────────────────────────────────────
      paymentSuccess: {
        title: 'Pagamento Aprovado!',
        description: 'Seu memorial foi publicado com sucesso e já está disponível.',
        paymentId: 'ID do Pagamento: {{id}}',
        btnMemorials: 'Ver Meus Memoriais',
        btnHome: 'Voltar ao Início',
      },

      // ── Payment Failure ──────────────────────────────────────────────────────
      paymentFailure: {
        title: 'Pagamento Não Realizado',
        description: 'O pagamento não foi concluído. Você pode tentar novamente.',
        btnTryAgain: 'Tentar Novamente',
        btnHome: 'Voltar ao Início',
      },

      // ── Payment Pending ──────────────────────────────────────────────────────
      paymentPending: {
        title: 'Pagamento Pendente',
        description: 'Estamos aguardando a confirmação do seu pagamento. Assim que for aprovado, seu memorial será publicado automaticamente.',
        notice: 'Você receberá uma notificação quando o pagamento for confirmado. Isso pode levar alguns minutos.',
        btnMemorials: 'Ver Meus Memoriais',
        btnHome: 'Voltar ao Início',
      },

      // ── How It Works Page ────────────────────────────────────────────────────
      howItWorksHero: {
        eyebrow: 'Como Funciona',
        titleLine1: 'Simples assim.',
        titleLine2: '3 passos, eterno.',
        description: 'Criar um memorial eterno é simples, rápido e feito com muito respeito. Em apenas 3 passos você homenageia quem você ama.',
        cta: 'Criar memorial gratuito',
        badge1: '✦ Passo 01 — Criar',
        badge2: '✦ Passo 02 — Visualizar',
        badge3: '✦ Passo 03 — Publicar',
      },

      includedSection: {
        eyebrow: 'Detalhes',
        title: 'O que está',
        titleItalic: 'incluído?',
        items: [
          { title: 'Memorial Digital Completo', desc: 'Página personalizada com fotos, biografia e áudio' },
          { title: 'QR Code Único', desc: 'Acesso instantâneo ao memorial de qualquer lugar' },
          { title: 'Galeria de Fotos', desc: 'Até 10 imagens para preservar momentos especiais' },
          { title: 'Placa de Aço Inox (Opcional)', desc: 'Durabilidade e elegância para eternizar a homenagem' },
          { title: 'Hospedagem Eterna', desc: 'Seu memorial fica disponível para sempre' },
          { title: 'Suporte Dedicado', desc: 'Atendimento via WhatsApp para qualquer dúvida' },
        ],
      },

      stepsSection: {
        eyebrow: 'O Processo',
        title: 'Criar, visualizar e publicar.',
        description: `Preencha, veja o resultado e escolha um plano.
        Se não terminar no momento, salve como rascunho e continue depois.`,
        descriptionMobile: `Crie no seu tempo.
        Salve e continue quando quiser.`,
        stepLabel: 'STEP',
        steps: [
          {
            number: '01',
            title: 'Crie o Memorial',
            description: 'Preencha as informações da pessoa homenageada com carinho: dados pessoais, uma frase especial, biografia, galeria de fotos e até um áudio de homenagem. Tudo de forma simples e guiada, para que você possa expressar todo o amor que sente.',
            highlight: 'Criar é gratuito!',
            cta: 'Começar agora',
          },
          {
            number: '02',
            title: 'Veja o Resultado',
            description: 'Assim que você terminar, o memorial será exibido pronto na tela para você visualizar. Veja como ficou a homenagem completa, confira cada detalhe e sinta o resultado. O memorial fica salvo no seu perfil, pronto para quando você decidir publicar.',
            highlight: 'Prévia instantânea',
            cta: 'Ver exemplo',
          },
          {
            number: '03',
            title: 'Escolha um Plano',
            description: 'Se gostar do resultado, escolha o plano que melhor atende suas necessidades: o Plano Digital para publicar o memorial online, ou o Plano Placa QR Code para receber também uma placa física de aço inox com QR Code gravado para colocar no túmulo.',
            highlight: 'Pague só se quiser publicar',
            cta: 'Ver planos',
          },
        ],
      },

      ctaSection: {
        eyebrow: 'Pronto para começar?',
        titleLine1: 'Crie agora,',
        titleLine2: 'gratuitamente.',
        cta: 'Começar Agora',
      },

      // ── Why Preserve Memories Page ───────────────────────────────────────────
      whyPreservePage: {
        hero: {
          dates: '1948 · 2024',
          title: 'Quantas histórias dos seus bisavós você realmente conhece?',
          description: 'Uma lápide mostra apenas um nome e duas datas. Mas entre essas datas existe uma vida inteira — histórias, conquistas, amor e memórias que merecem ser preservadas para sempre.',
          ticker: ['infância · ', 'amor · ', 'conquistas · ', 'família · ', 'aventuras · ', 'legado · ', 'amizades · ', 'fé · '],
          cta: 'Criar um memorial',
          ctaSecondary: 'Ver exemplos',
        },
        problem: {
          eyebrow: 'O problema real',
          title: 'As memórias desaparecem.\nSilenciosamente. Para sempre.',
          description: 'A maioria das famílias só percebe quando já é tarde demais. Quando aquela história que só o avô sabia contar… não existe mais.',
          stat: '"Grande parte das histórias familiares se perde após poucas gerações."',
          cards: [
            { title: 'Histórias que nunca foram registradas', text: 'Cada pessoa que parte leva consigo segredos, causos e sabedoria que ninguém teve tempo de guardar.' },
            { title: 'Gerações que não se conhecem', text: 'Seus netos crescerão sem saber quem foram seus antepassados e o que os tornava especiais.' },
            { title: 'A memória apaga com o tempo', text: 'Em menos de 3 gerações, uma vida inteira desaparece. Em 75 anos, só restam as datas.' },
          ],
        },
        meaning: {
          eyebrow: 'O que é um memorial',
          quote: '"Não é apenas uma página.\nÉ um ato de amor que dura para sempre."',
          description: 'Um memorial digital é a decisão de não deixar que o tempo apague uma vida. É escolher que aquela história continue sendo contada.',
          pillars: [
            { title: 'Um legado', desc: 'O que uma pessoa construiu ao longo de toda uma vida, preservado e transmitido para as gerações futuras.' },
            { title: 'Uma homenagem', desc: 'A mais bela forma de dizer que uma vida importou. Que aquela pessoa fez diferença. Que ela é amada.' },
            { title: 'Uma memória eterna', desc: 'Não importa quanto tempo passe. O amor registrado em um memorial nunca se apaga. Nunca some.' },
          ],
        },
        whatIs: {
          eyebrow: 'O produto',
          title: 'O que existe dentro\nde um memorial digital',
          description: 'Muito mais do que uma página. Um lugar onde uma vida inteira é preservada, revisitada e amada.',
          browserUrl: 'remember.com.br/memorial/joao-silva',
          browserName: 'João Silva',
          browserDates: '1948 – 2024',
          browserQuote: '"Um homem de família, pai dedicado, amigo para sempre lembrado por todos que tiveram o privilégio de conhecê-lo..."',
          features: [
            { title: 'História de vida', desc: 'Uma biografia completa com os momentos mais importantes, escrita com carinho pela família.' },
            { title: 'Galeria de fotos', desc: 'Dezenas de fotos organizadas, acessíveis de qualquer celular com um simples escaneamento.' },
            { title: 'Áudio de homenagem', desc: 'Uma música especial, uma oração ou mensagem de voz que representa quem partiu.' },
            { title: 'Mensagens da família', desc: 'Familiares e amigos podem deixar mensagens eternas de amor, saudade e gratidão.' },
            { title: 'Momentos especiais', desc: 'Datas, conquistas e marcos da vida registrados de forma visual e emocional.' },
            { title: 'QR Code na lápide', desc: 'Uma placa de aço inox com QR Code que conecta quem visita o túmulo ao memorial digital.' },
          ],
        },
        moments: {
          eyebrow: 'Cada vida',
          title: 'Pense em todos os momentos\nque compõem uma vida.',
          description: 'Cada um deles é único. Cada um deles merece ser lembrado. E agora, todos podem ser preservados.',
          items: [
            { key: 'infancia', label: 'Infância', desc: 'As primeiras memórias, brincadeiras e descobertas que formaram quem ela era.' },
            { key: 'amor', label: 'Amor', desc: 'Encontros, casamentos e os laços que definiram uma vida inteira.' },
            { key: 'conquistas', label: 'Conquistas', desc: 'Formatura, carreira e os sonhos que um dia se tornaram realidade.' },
            { key: 'familia', label: 'Família', desc: 'Os filhos, netos e gerações que vieram depois e carregam seu legado.' },
            { key: 'aventuras', label: 'Aventuras', desc: 'Viagens, novas descobertas e experiências que ela escolheu vivenciar.' },
            { key: 'fe', label: 'Fé', desc: 'As crenças e valores espirituais que guiaram cada passo da vida.' },
            { key: 'amizades', label: 'Amizades', desc: 'Os amigos verdadeiros que estiveram ao lado nos momentos mais importantes.' },
            { key: 'legado', label: 'Legado', desc: 'O que ela deixou no mundo: amor, inspiração e diferença.' },
          ],
        },
        howItWorks: {
          eyebrow: 'Processo',
          title: 'Em 4 passos simples,\num legado eterno.',
          description: 'Pensado para ser simples, bonito e significativo. Do início ao memorial publicado.',
          stepLabel: 'Passo',
          footer: 'Criar o memorial é gratuito · Você só paga se quiser publicar',
          steps: [
            { n: '01', title: 'Crie o memorial', desc: 'Preencha o nome, datas, história de vida, fotos e momentos especiais. Tudo simples e guiado.' },
            { n: '02', title: 'Adicione memórias', desc: 'Envie fotos, áudios e mensagens. A galeria é montada automaticamente de forma bonita e emocional.' },
            { n: '03', title: 'Receba a placa QR Code', desc: 'Após escolher um plano, você recebe uma placa de aço inox com QR Code gravado permanentemente.' },
            { n: '04', title: 'Família acessa para sempre', desc: 'Qualquer pessoa com um celular pode escanear e acessar o memorial. Para sempre. Em qualquer lugar.' },
          ],
        },
        beforeAfter: {
          eyebrow: 'A transformação',
          title: 'O que muda com um\nmemorial digital',
          description: 'Uma decisão simples. Uma diferença que dura para sempre.',
          beforeLabel: 'Sem memorial',
          beforeTitle: 'A memória se perde',
          afterLabel: 'Com memorial digital',
          afterTitle: 'A memória vive para sempre',
          cta: 'Criar memorial agora — é gratuito',
          beforeItems: [
            'Fotos guardadas em caixas e gavetas',
            'Histórias perdidas para sempre',
            'Família se lembrando cada vez menos',
            'Uma vida apagada com o passar do tempo',
            'Filhos que nunca conhecerão o avô de verdade',
            'Voz, personalidade e risada esquecidas',
          ],
          afterItems: [
            'Memorial digital acessível de qualquer lugar',
            'História de vida completa e preservada',
            'Família reconectada às memórias a qualquer hora',
            'Filhos e netos conhecendo o legado familiar',
            'Memórias preservadas para gerações futuras',
            'QR Code na lápide conecta físico e digital',
          ],
        },
        testimonials: {
          eyebrow: 'Avaliações',
          title: 'O que as famílias dizem',
          description: 'Histórias reais de quem escolheu preservar para sempre.',
          items: [
            { name: 'Maria Souza', role: 'Filha', text: 'Agora meus netos podem conhecer a história do bisavô deles. O memorial virou um tesouro da nossa família.' },
            { name: 'João Carlos', role: 'Filho', text: 'O QR Code na lápide do meu pai é algo que não tem preço. Cada visita se tornou especial de um jeito diferente.' },
            { name: 'Ana Paula', role: 'Neta', text: 'Criei o memorial para minha avó e toda a família ficou emocionada. Deu pra sentir ela presente de novo.' },
          ],
        },
        finalCta: {
          eyebrow: 'Comece agora',
          title: 'Crie um memorial que\ndura para sempre.',
          description: 'Não espere o tempo apagar as memórias. Preserve hoje a história de quem você ama — para que as próximas gerações possam conhecer, amar e se orgulhar de onde vieram.',
          cta: 'Criar memorial gratuito',
          ctaSecondary: 'Ver exemplos de memorials',
          stats: [
            { n: '100%', label: 'Gratuito para criar' },
            { n: '∞', label: 'Disponível para sempre' },
            { n: '24/7', label: 'Acessível de qualquer lugar' },
          ],
        },
      },

      // ── Explore Page ──────────────────────────────────────────────────────────────────
      explore: {
        eyebrow: 'Histórias que vivem',
        title: 'Explorar',
        titleItalic: 'Memoriais',
        description: 'Homenagens eternas que preservam memórias e histórias de vidas especiais.',
        empty: 'Ainda não há memoriais',
        emptyDesc: 'Seja o primeiro a criar um memorial e compartilhar uma história de vida.',
        viewMemorial: 'Ver memorial',
        loading: 'Carregando...',
        loadMore: 'Ver mais ({{count}} restantes)',
      },

      preview: {
        successTitle: 'Memorial criado com sucesso!',
        successDesc: 'Veja abaixo como ficou sua homenagem. Escolha um plano para publicar.',
        draftMode: 'Modo de visualização — Rascunho',
        choosePlan: 'Escolher Plano',
        createOther: 'Criar outro',
        footer: 'Criar é gratuito · Pague somente ao publicar',
      },

      edit: {
        eyebrow: 'Editar memorial',
        published: 'Publicado',
        draft: 'Rascunho',
        back: 'Voltar',
        cancel: 'Cancelar',
        save: 'Salvar alterações',
        saving: 'Salvando...',
        photoCard: 'Foto do Homenageado',
        photoUpload: 'Clique para enviar foto',
        photoChange: 'Clique para trocar a foto',
        photoUploading: 'Enviando...',
        personalCard: 'Dados Pessoais',
        visibilityCard: 'Visibilidade no Explorar',
        visibleLabel: 'Visível no Explorar',
        hiddenLabel: 'Oculto do Explorar',
        visibleDesc: 'Qualquer pessoa pode encontrar este memorial',
        hiddenDesc: 'Somente quem tiver o link pode acessar',
        visibilityNote: '💡 Independente desta configuração, qualquer pessoa com o link direto do memorial poderá visitá-lo.',
        contentCard: 'Conteúdo do Memorial',
        galleryCard: 'Galeria de Memórias',
        galleryUpload: 'Adicionar fotos à galeria',
        audioCard: 'Áudio de Homenagem',
        audioUpload: 'Enviar áudio de homenagem',
        audioRemove: 'Remover áudio',
      },

      institutional: {
        about: {
          heroTag: 'Sobre nós',
          heroTitle: 'Nascemos para preservar o que mais importa.',
          heroSubtitle: 'A Remember QRCode é uma plataforma brasileira dedicada à criação de memoriais digitais permanentes, conectando histórias de vida ao presente por meio da tecnologia.',
          whoWeAreTitle: 'Quem somos',
          whoWeAre1: 'A Remember QRCode é uma empresa brasileira criada com o propósito de transformar a forma como honramos e lembramos as pessoas que amamos. Acreditamos que toda vida merece ser contada, celebrada e preservada para as gerações futuras.',
          whoWeAre2: 'Combinamos tecnologia acessível com um produto físico de alta qualidade — a placa de aço inoxidável com QR Code — para criar uma ponte permanente entre o mundo físico e o digital.',
          missionTitle: 'Nossa missão',
          mission: 'Oferecer às famílias uma forma digna, acessível e duradoura de preservar a memória de seus entes queridos, com respeito, simplicidade e cuidado em cada etapa do processo.',
          visionTitle: 'Nossa visão',
          vision: 'Ser a principal plataforma de memoriais digitais do Brasil, reconhecida pela qualidade dos produtos, pelo atendimento humanizado e pelo impacto positivo que geramos nas famílias brasileiras.',
          valuesTitle: 'Nossos valores',
          values: [
            { icon: '🤍', title: 'Respeito e empatia', text: 'Cada memorial é único. Tratamos cada história com o cuidado e a sensibilidade que ela merece.' },
            { icon: '🔒', title: 'Confiança e segurança', text: 'Seus dados e o memorial criado são armazenados com segurança e permanecem disponíveis permanentemente.' },
            { icon: '✨', title: 'Simplicidade', text: 'Criamos uma experiência simples e intuitiva para que qualquer pessoa possa criar um memorial bonito.' },
            { icon: '🌐', title: 'Tecnologia com propósito', text: 'Usamos tecnologia não por tendência, mas para criar algo com significado real para as famílias.' },
          ],
          howItWorksTitle: 'Como funciona',
          howItWorks1: 'Qualquer pessoa pode criar um memorial digital gratuitamente em nossa plataforma. Após a criação, o memorial fica salvo como rascunho, permitindo revisões antes da publicação.',
          howItWorks2: 'Quando o cliente estiver satisfeito, pode escolher entre o <strong>Plano Digital</strong> — que publica o memorial online com link e QR Code exclusivos — ou o <strong>Plano Placa QR Code</strong>, que inclui a produção e entrega de uma placa física em aço inox para fixação em túmulos, jazigos ou locais de homenagem.',
          affiliatesTitle: 'Parceria com funerárias e cemitérios',
          affiliates: 'Contamos com um programa de affiliatees voltado a funerárias e cemitérios. Parceiros recebem um código exclusivo que oferece desconto aos clientes e gera comissão progressiva sobre as vendas realizadas. Entre em contato para saber mais.',
          cta: 'Criar memorial gratuito',
        },

        delivery: {
          heroTag: 'Entrega',
          heroTitle: 'Política de Entrega',
          heroSubtitle: 'Saiba tudo sobre os prazos, formas de envio e acompanhamento do seu pedido.',
          s1Title: '1. Abrangência da entrega',
          s1: 'A Remember QRCode realiza entregas para todo o território nacional. O envio da placa física é feito exclusivamente após a confirmação do pagamento e a aprovação do memorial pelo cliente.',
          s2Title: '2. Prazo de produção e envio',
          s2Intro: 'Após a confirmação do pagamento, o pedido segue as seguintes etapas:',
          s2Items: [
            '<strong>Produção da placa:</strong> até 5 dias úteis.',
            '<strong>Despacho para transportadora:</strong> em até 2 dias úteis após a finalização.',
            '<strong>Entrega ao destinatário:</strong> de 3 a 8 dias úteis após o despacho, conforme a região.',
          ],
          s2Footer: 'O prazo total estimado é de <strong>7 a 15 dias úteis</strong> a partir da confirmação do pagamento. Regiões mais remotas podem apresentar prazos superiores.',
          s3Title: '3. Rastreamento do pedido',
          s3a: 'Assim que o pedido for despachado, o cliente receberá um e-mail com o código de rastreamento e o link para acompanhar a entrega diretamente no site da transportadora.',
          s3b: 'Todas as atualizações de status também são enviadas por e-mail ao longo do processo:',
          s3Items: [
            'Memorial criado e pagamento confirmado.',
            'Pedido em produção.',
            'Produto finalizado e em preparação para envio.',
            'Pedido despachado (com código de rastreamento).',
            'Pedido entregue.',
          ],
          s4Title: '4. Frete',
          s4: 'O valor do frete é calculado automaticamente no momento da compra, com base no CEP de entrega informado pelo cliente. O valor é exibido de forma clara antes da finalização do pedido.',
          s5Title: '5. Endereço de entrega',
          s5a: 'O cliente é responsável por informar corretamente o endereço de entrega. Em caso de endereço incorreto ou incompleto, a Remember QRCode não se responsabiliza por atrasos ou não entrega.',
          s5b: 'Caso seja necessário corrigir o endereço após a confirmação do pedido, entre em contato imediatamente com nossa equipe pelo WhatsApp ou e-mail. Só é possível realizar a alteração se o pedido ainda não tiver sido despachado.',
          s6Title: '6. Tentativa de entrega',
          s6a: 'A transportadora realizará até 3 tentativas de entrega no endereço informado. Caso não haja ninguém para receber, o cliente será orientado a retirar o objeto em um ponto de coleta próximo, conforme as diretrizes da transportadora.',
          s6b: 'Após o prazo de guarda no ponto de coleta, o objeto pode ser devolvido ao remetente. Nesse caso, um novo envio poderá ser realizado mediante pagamento de novo frete.',
          s7Title: '7. Avaria ou extravio',
          s7a: 'Em caso de avaria ou extravio durante o transporte, o cliente deve entrar em contato com nossa equipe em até <strong>7 dias após a data de entrega prevista</strong>, apresentando fotos do produto recebido (se houver avaria) ou informando a ausência de entrega.',
          s7b: 'Após análise, providenciaremos a produção e reenvio de uma nova placa sem custo adicional ao cliente.',
          s8Title: '8. Dúvidas sobre entrega',
          s8: 'Para qualquer dúvida relacionada ao envio do seu pedido, entre em contato com nossa equipe pelo WhatsApp (+55 22 99208-0811) ou e-mail (rememberqrcode@gmail.com). Respondemos em até 1 dia útil.',
        },

        privacy: {
          heroTag: 'Privacidade',
          heroTitle: 'Política de Privacidade',
          heroSubtitle: 'Saiba como coletamos, usamos e protegemos suas informações pessoais na Remember QRCode.',
          s1Title: '1. Quais dados coletamos',
          s1Intro: 'Ao utilizar nossa plataforma, podemos coletar as seguintes informações:',
          s1Items: [
            '<strong>Dados de cadastro:</strong> nome, e-mail e senha (criptografada).',
            '<strong>Dados do memorial:</strong> nome, foto, biografia, datas e demais informações inseridas voluntariamente pelo usuário.',
            '<strong>Dados de pagamento:</strong> processados integralmente por gateways certificados (não armazenamos dados de cartão).',
            '<strong>Dados de entrega:</strong> endereço fornecido para envio da placa física.',
            '<strong>Dados de navegação:</strong> cookies e dados técnicos de acesso (IP, navegador, dispositivo), utilizados exclusivamente para melhoria da plataforma.',
          ],
          s2Title: '2. Como utilizamos seus dados',
          s2Intro: 'Os dados coletados são utilizados exclusivamente para:',
          s2Items: [
            'Criar e gerenciar sua conta e os memoriais associados.',
            'Processar pagamentos e emitir confirmações de compra.',
            'Enviar atualizações sobre o pedido por e-mail (produção, despacho, entrega).',
            'Prestar suporte ao cliente quando solicitado.',
            'Melhorar continuamente a experiência na plataforma.',
          ],
          s2Footer: '<strong>Não vendemos, alugamos nem compartilhamos seus dados pessoais com terceiros</strong> para fins comerciais ou publicitários.',
          s3Title: '3. Armazenamento e segurança',
          s3a: 'Todos os dados são armazenados em servidores seguros com criptografia. Adotamos medidas técnicas e administrativas adequadas para proteger suas informações contra acesso não autorizado, perda ou vazamento.',
          s3b: 'As senhas dos usuários são armazenadas com hash criptográfico e nunca podem ser acessadas diretamente por nenhum colaborador da empresa.',
          s4Title: '4. Compartilhamento de dados',
          s4Intro: 'Seus dados podem ser compartilhados apenas nas seguintes situações:',
          s4Items: [
            '<strong>Transportadoras:</strong> nome e endereço de entrega, exclusivamente para entrega da placa física.',
            '<strong>Gateway de pagamento:</strong> dados necessários para processamento da transação.',
            '<strong>Obrigações legais:</strong> quando exigido por lei ou autoridade competente.',
          ],
          s5Title: '5. Seus direitos (LGPD)',
          s5Intro: 'Em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você tem direito a:',
          s5Items: [
            'Confirmar a existência de tratamento de seus dados.',
            'Acessar os dados que temos sobre você.',
            'Corrigir dados incompletos ou desatualizados.',
            'Solicitar a exclusão de seus dados pessoais.',
            'Revogar o consentimento dado anteriormente.',
          ],
          s5Footer: 'Para exercer qualquer um desses direitos, entre em contato com nossa equipe pelo e-mail ou WhatsApp disponíveis no rodapé do site.',
          s6Title: '6. Cookies',
          s6: 'Utilizamos cookies estritamente necessários para o funcionamento da plataforma e cookies analíticos para entender como os usuários navegam no site. Você pode desativar os cookies no seu navegador, porém isso pode afetar algumas funcionalidades.',
          s7Title: '7. Retenção de dados',
          s7: 'Os dados são mantidos enquanto sua conta estiver ativa. Após a exclusão da conta, os dados pessoais são removidos em até 30 dias, exceto aqueles exigidos por obrigações legais ou fiscais.',
          s8Title: '8. Atualizações desta política',
          s8a: 'Esta política pode ser atualizada periodicamente. Em caso de alterações relevantes, notificaremos os usuários cadastrados por e-mail. A data da última atualização estará sempre indicada no final desta página.',
          s8Date: 'Última atualização: junho de 2025.',
        },

        terms: {
          heroTag: 'Legal',
          heroTitle: 'Termos e Condições',
          heroSubtitle: 'Leia com atenção as condições de uso da plataforma Remember QRCode antes de utilizar nossos serviços.',
          s1Title: '1. Aceitação dos termos',
          s1: 'Ao criar uma conta, utilizar a plataforma ou adquirir qualquer produto ou serviço da Remember QRCode, o usuário declara que leu, compreendeu e concorda com os presentes Termos e Condições de Uso. Caso não concorde com qualquer disposição, recomendamos que não utilize a plataforma.',
          s2Title: '2. Descrição dos serviços',
          s2Intro: 'A Remember QRCode oferece:',
          s2Items: [
            'Criação gratuita de memoriais digitais em formato de rascunho.',
            'Publicação oficial do memorial online mediante contratação do Plano Digital.',
            'Produção e entrega de placa física em aço inoxidável com QR Code, mediante contratação do Plano Placa QR Code.',
          ],
          s3Title: '3. Cadastro e conta do usuário',
          s3a: 'Para utilizar a plataforma, é necessário criar uma conta com informações verdadeiras e atualizadas. O usuário é responsável pela confidencialidade de sua senha e por todas as atividades realizadas em sua conta.',
          s3b: 'A Remember QRCode reserva-se o direito de suspender ou excluir contas que violem estes termos, contenham informações falsas ou apresentem comportamento abusivo na plataforma.',
          s4Title: '4. Conteúdo dos memoriais',
          s4Intro: 'O usuário é integralmente responsável pelo conteúdo inserido nos memoriais. É expressamente proibido publicar conteúdo que:',
          s4Items: [
            'Seja falso, enganoso ou difamatório.',
            'Viole direitos autorais, de imagem ou de privacidade de terceiros.',
            'Contenha material ofensivo, discriminatório, violento ou ilegal.',
            'Faça referência a pessoas vivas sem autorização explícita.',
          ],
          s4Footer: 'A Remember QRCode poderá remover qualquer conteúdo que viole estas diretrizes, sem aviso prévio e sem direito a reembolso.',
          s5Title: '5. Pagamentos e planos',
          s5a: 'Os valores dos planos são os vigentes no momento da contratação. O pagamento é processado por gateways certificados e seguros. Após a confirmação do pagamento, o pedido entra em processamento imediatamente.',
          s5b: 'Não realizamos parcelamento fora das condições disponibilizadas pelo gateway de pagamento. Promoções e descontos (incluindo os gerados por códigos de affiliatees) não são cumulativos.',
          s6Title: '6. Prazo de entrega',
          s6a: 'O prazo de produção e entrega da placa física é de 7 a 15 dias úteis após a confirmação do pagamento. O cliente receberá o código de rastreamento por e-mail assim que o pedido for despachado.',
          s6b: 'Atrasos causados por transportadoras, greves, desastres naturais ou outros eventos fora do controle da empresa não geram direito a reembolso automático, mas serão comunicados ao cliente.',
          s7Title: '7. Disponibilidade do memorial digital',
          s7: 'Os memoriais publicados ficam disponíveis permanentemente na plataforma, salvo nos casos de violação destes termos ou solicitação expressa do titular da conta. A Remember QRCode empreenderá todos os esforços razoáveis para manter a plataforma disponível 24 horas por dia, 7 dias por semana.',
          s8Title: '8. Programa de affiliatees',
          s8a: 'Funerárias, cemitérios e outros parceiros podem participar do programa de affiliatees mediante adesão formal. O parceiro recebe um código exclusivo que gera desconto para clientes e comissão progressiva (10%, 15% ou 20%) sobre as vendas realizadas com o código.',
          s8b: 'As comissões são calculadas mensalmente e pagas conforme acordado no contrato de parceria. A Remember QRCode reserva-se o direito de encerrar parcerias que violem os princípios éticos da plataforma.',
          s9Title: '9. Propriedade intelectual',
          s9: 'Todo o conteúdo da plataforma — marca, logotipo, design, textos institucionais e código — é de propriedade exclusiva da Remember QRCode e protegido por lei. É proibida a reprodução, cópia ou uso não autorizado de qualquer elemento da plataforma.',
          s10Title: '10. Limitação de responsabilidade',
          s10: 'A Remember QRCode não se responsabiliza por danos indiretos, lucros cessantes ou prejuízos decorrentes do uso da plataforma, exceto nos casos expressamente previstos em lei. Nossa responsabilidade está limitada ao valor pago pelo cliente no serviço contratado.',
          s11Title: '11. Alterações nos termos',
          s11: 'Estes Termos e Condições podem ser atualizados a qualquer momento. Os usuários cadastrados serão notificados por e-mail em caso de alterações relevantes. O uso continuado da plataforma após a notificação implica aceitação dos novos termos.',
          s12Title: '12. Foro e legislação aplicável',
          s12a: 'Estes termos são regidos pela legislação brasileira. Em caso de conflito, as partes elegem o foro da comarca do domicílio do consumidor, conforme previsto no Código de Defesa do Consumidor.',
          s12Date: 'Última atualização: junho de 2025.',
        },

        responsibility: {
          heroTag: 'Política',
          heroTitle: 'Política de Responsabilidade',
          heroSubtitle: 'Conheça nossos compromissos com você, com os memoriais criados e com a conduta ética da nossa plataforma.',
          s1Title: '1. Nosso compromisso',
          s1: 'A Remember QRCode assume plena responsabilidade pela qualidade dos serviços oferecidos, pela segurança das informações armazenadas e pelo respeito ao cliente em todas as etapas da jornada — desde a criação do memorial até a entrega do produto físico.',
          s2Title: '2. Responsabilidade sobre o conteúdo dos memoriais',
          s2a: 'O conteúdo inserido nos memoriais — textos, fotos, áudios e demais informações — é de exclusiva responsabilidade do usuário que o criou. A Remember QRCode não produz, edita nem valida o conteúdo publicado pelos clientes.',
          s2Intro: 'Ao utilizar a plataforma, o usuário declara que:',
          s2Items: [
            'Possui os direitos sobre as imagens e informações inseridas.',
            'O conteúdo não viola direitos de terceiros, leis vigentes ou normas de conduta.',
            'As informações são verídicas e referem-se a pessoa real.',
          ],
          s2Footer: 'A Remember QRCode reserva-se o direito de remover, sem aviso prévio, qualquer memorial que contenha conteúdo ofensivo, ilegal ou que viole os Termos e Condições da plataforma.',
          s3Title: '3. Responsabilidade sobre o produto físico',
          s3a: 'A Remember QRCode é responsável pela produção e envio das placas físicas dentro do prazo estabelecido (7 a 15 dias úteis após a confirmação do pagamento). Em caso de defeito de fabricação ou dano no transporte, nos comprometemos a realizar a substituição do produto sem custo adicional ao cliente.',
          s3Intro: 'Não nos responsabilizamos por:',
          s3Items: [
            'Atrasos causados por transportadoras ou fatores externos.',
            'Danos ocasionados por uso inadequado ou instalação incorreta da placa.',
            'Endereço de entrega incorreto informado pelo cliente.',
          ],
          s4Title: '4. Responsabilidade sobre o serviço digital',
          s4a: 'Nos comprometemos a manter os memoriais publicados disponíveis de forma contínua. Em casos de manutenção programada ou ocorrências técnicas, comunicaremos os clientes com antecedência sempre que possível.',
          s4b: 'A plataforma não se responsabiliza por indisponibilidades causadas por falhas de terceiros (provedores de internet, servidores externos, etc.).',
          s5Title: '5. Conduta ética',
          s5: 'A Remember QRCode não utiliza as informações dos memoriais para fins comerciais, publicitários ou de análise de dados pessoais. Todas as informações são tratadas com sigilo, respeito e em conformidade com a Lei Geral de Proteção de Dados (LGPD).',
          s6Title: '6. Canal de comunicação',
          s6: 'Em caso de dúvidas, reclamações ou solicitações relacionadas a esta política, entre em contato com nossa equipe pelo WhatsApp ou e-mail disponíveis no rodapé do site. Respondemos em até 2 dias úteis.',
        },

        returns: {
          heroTag: 'Trocas e Devoluções',
          heroTitle: 'Política de Troca, Devolução e Reembolso',
          heroSubtitle: 'Transparência total sobre seus direitos e nossos procedimentos em casos de cancelamento, defeito ou insatisfação.',
          s1Title: '1. Direito de arrependimento',
          s1a: 'Conforme o Código de Defesa do Consumidor (Art. 49), o cliente tem o direito de cancelar a compra em até <strong>7 dias corridos</strong> a partir da data de confirmação do pagamento, sem necessidade de justificativa.',
          s1b: 'O cancelamento dentro deste prazo garante o reembolso integral do valor pago, desde que o produto físico (placa) não tenha sido entregue ao cliente.',
          s2Title: '2. Como solicitar o cancelamento',
          s2Intro: 'Para solicitar o cancelamento dentro do prazo legal, entre em contato pelos canais oficiais:',
          s2Items: [
            'WhatsApp: +55 22 99208-0811',
            'E-mail: rememberqrcode@gmail.com',
          ],
          s2Footer: 'Informe o número do pedido, o e-mail cadastrado e o motivo do cancelamento. Nossa equipe confirmará o recebimento da solicitação em até 1 dia útil.',
          s3Title: '3. Prazo de reembolso',
          s3Intro: 'Após a confirmação do cancelamento, o reembolso será processado em até <strong>10 dias úteis</strong>, pela mesma forma de pagamento utilizada na compra:',
          s3Items: [
            '<strong>Cartão de crédito:</strong> estorno na fatura em até 2 ciclos de cobrança (conforme a operadora).',
            '<strong>PIX ou boleto:</strong> transferência para a conta indicada pelo cliente em até 5 dias úteis.',
          ],
          s4Title: '4. Troca por defeito de fabricação',
          s4Intro: 'Caso a placa física chegue com defeito visível, dano causado pelo transporte ou divergência em relação ao memorial aprovado, o cliente deverá entrar em contato em até <strong>7 dias após o recebimento</strong>, informando:',
          s4Items: [
            'Número do pedido.',
            'Foto ou vídeo do defeito.',
            'Descrição do problema.',
          ],
          s4Footer: 'Após a análise, realizaremos a produção e envio de uma nova placa sem nenhum custo adicional ao cliente.',
          s5Title: '5. Casos não cobertos pela política de troca',
          s5Intro: 'Não realizamos trocas ou reembolsos nos seguintes casos:',
          s5Items: [
            'Danos causados por uso inadequado ou instalação incorreta da placa.',
            'Arrependimento após a entrega do produto físico.',
            'Erros nas informações do memorial inseridas pelo próprio cliente (conferência é de responsabilidade do cliente antes da aprovação).',
            'Cancelamentos solicitados após o prazo legal de 7 dias.',
          ],
          s6Title: '6. Plano Digital — cancelamento',
          s6: 'Para o Plano Digital, o cancelamento com reembolso é aceito dentro do prazo de 7 dias corridos, desde que o link do memorial não tenha sido amplamente divulgado ou utilizado publicamente de forma irreversível.',
          s7Title: '7. Dúvidas',
          s7: 'Nossa equipe está disponível para esclarecer qualquer dúvida relacionada a esta política. Entre em contato pelo WhatsApp ou e-mail disponíveis no rodapé do site.',
        },
      },

      userPages: {
        dashboard: {
          eyebrow: 'Painel do usuário',
          title: 'Bem-vindo,',
          subtitle: 'Gerencie seus memoriais e homenagens',
          menu: [
            { title: 'Meus Memoriais', description: 'Visualize e gerencie seus memoriais' },
            { title: 'Minhas Compras', description: 'Histórico de pedidos e pagamentos' },
            { title: 'Minha Conta', description: 'Configurações de perfil' },
          ],
          support: {
            title: 'Precisa de Ajuda?',
            subtitle: 'Entre em contato com nosso suporte via WhatsApp',
            cta: 'Falar no WhatsApp',
          },
        },

        myMemorials: {
          eyebrow: 'Painel do usuário',
          title: 'Meus Memoriais',
          createBtn: '+ Criar Novo Memorial',
          emptyTitle: 'Nenhum memorial ainda',
          emptyDesc: 'Você ainda não criou nenhum memorial. Comece agora a preservar memórias.',
          emptyBtn: 'Criar Primeiro Memorial',
          published: 'Publicado',
          draft: 'Rascunho',
          plan: 'Plano',
          actionView: 'Ver',
          actionEdit: '✏️ Editar',
          actionPublish: 'Publicar',
          actionDelete: 'Excluir rascunho',
          deleteModal: {
            title: 'Excluir memorial?',
            about: 'Você está prestes a excluir o memorial de',
            warning: 'Esta ação é permanente e não pode ser desfeita. Todas as fotos, textos e configurações serão apagados.',
            cancel: 'Cancelar',
            confirm: 'Excluir',
            deleting: 'Excluindo...',
          },
          toastSuccess: 'Memorial excluído com sucesso.',
          toastError: 'Erro ao excluir memorial. Tente novamente.',
        },

        myPurchases: {
          eyebrow: 'Painel do usuário',
          title: 'Minhas Compras',
          emptyTitle: 'Nenhuma compra ainda',
          emptyDesc: 'Você ainda não realizou nenhuma compra',
          order: 'Pedido',
          plan: 'Plano',
          mpId: 'ID Mercado Pago',
          refund: 'Reembolso em até 7 dias úteis',
          cancelRequested: 'Cancelamento Solicitado',
          statuses: {
            approved: 'Aprovado',
            paid: 'Pago',
            pending: 'Pendente',
            rejected: 'Rejeitado',
            in_process: 'Processando',
            in_production: 'Em Produção',
            produced: 'Produzido',
            shipped: 'Enviado',
            entregue: 'Entregue',
            cancelled: 'Cancelado',
          },
        },

        profile: {
          eyebrow: 'Painel do usuário',
          backBtn: 'Voltar ao Dashboard',
          title: 'Minha Conta',
          subtitle: 'Gerencie suas informações pessoais',
          photoCard: 'Foto de Perfil',
          photoChange: 'Alterar foto',
          photoAdd: 'Adicionar foto',
          photoUploading: 'Enviando...',
          photoHint: 'JPG, PNG ou GIF. Máximo 5MB.',
          infoCard: 'Informações Básicas',
          fieldName: 'Nome Completo',
          fieldEmail: 'E-mail',
          fieldEmailHint: 'O e-mail não pode ser alterado',
          fieldPhone: 'Telefone / WhatsApp',
          fieldBirth: 'Data de Nascimento',
          fieldCpf: 'CPF',
          addressCard: 'Endereço de Entrega',
          addressSubtitle: 'Usado para entrega de placas físicas',
          addressComplete: '✅ Completo',
          addressMissing: '⚠️ Não preenchido',
          addressSaveBtn: 'Salvar endereço de entrega',
          addressSaved: 'Endereço de entrega salvo!',
          addressError: 'Erro ao salvar endereço de entrega',
          saveBtn: 'Salvar Alterações',
          saving: 'Salvando...',
          toastSuccess: 'Perfil atualizado com sucesso!',
          toastError: 'Erro ao atualizar perfil',
          toastPhotoSuccess: 'Foto atualizada com sucesso!',
          toastPhotoError: 'Erro ao salvar foto',
          toastLoadError: 'Erro ao carregar dados do perfil',
          photoErrorType: 'Por favor, selecione uma imagem',
          photoErrorSize: 'A imagem deve ter no máximo 5MB',
          cepNotFound: 'CEP não encontrado.',
          cepFetchError: 'Erro ao buscar CEP. Preencha manualmente.',
          validation: {
            recipient_name: 'Nome do destinatário é obrigatório.',
            phone: 'Telefone é obrigatório.',
            zip_code: 'CEP é obrigatório.',
            street: 'Rua é obrigatória.',
            number: 'Número é obrigatório.',
            neighborhood: 'Bairro é obrigatório.',
            city: 'Cidade é obrigatória.',
            state: 'Estado é obrigatório.',
          },
          addressForm: {
            sectionTitle: 'Informe onde sua placa deve ser entregue',
            recipientNameLabel: 'Nome do destinatário *',
            recipientNamePlaceholder: 'Nome completo de quem receberá',
            phoneLabel: 'Telefone *',
            phonePlaceholder: '(00) 00000-0000',
            zipLabel: 'CEP *',
            zipPlaceholder: '00000-000',
            searchingCep: 'Buscando...',
            streetLabel: 'Rua / Logradouro *',
            streetPlaceholder: 'Nome da rua, avenida...',
            numberLabel: 'Número *',
            numberPlaceholder: '123',
            complementLabel: 'Complemento',
            complementPlaceholder: 'Apto, bloco, sala... (opcional)',
            neighborhoodLabel: 'Bairro *',
            neighborhoodPlaceholder: 'Nome do bairro',
            cityLabel: 'Cidade *',
            cityPlaceholder: 'Nome da cidade',
            stateLabel: 'Estado *',
            statePlaceholder: 'UF',
            cancel: 'Cancelar',
            saveAddressBtn: 'Salvar endereço de entrega',
          },
        },
      },
    },
  },

  // ══════════════════════════════════════════════════════════════════════════
  en: {
    translation: {

      nav: {
        home: 'Home',
        howItWorks: 'How It Works',
        whyPreserve: 'Why preserve?',
        explore: 'Explore',
        createMemorial: 'Create Memorial',
        login: 'Login',
        myAccount: 'My Account',
        myMemorials: 'My Memorials',
        myPurchases: 'My Purchases',
        support: 'Support',
        admin: 'Admin',
        logout: 'Logout',
        supporterPanel: 'Supporter Panel',
        myAccountSection: 'My account',
        closeMenu: 'Close menu',
        openMenu: 'Open menu',
        toggleLanguage: 'Toggle language',
      },

      auth: {
        signIn: 'Sign In',
        signUp: 'Sign Up',
        email: 'Email',
        password: 'Password',
        name: 'Name',
        continueWithGoogle: 'Continue with Google',
        alreadyHaveAccount: 'Already have an account?',
        dontHaveAccount: "Don't have an account?",
      },

      hero: {
        title: 'Turn memories\ninto tributes.',
        description: 'Keep the stories of those you love alive, accessible at any time, from anywhere.',
        cta: 'Create free memorial',
        ctaSecondary: 'Why preserve memories?',
      },

      howItWorks: {
        eyebrow: 'How It Works',
        title: 'In just 3 simple steps,\ncreate an eternal tribute.',
        description: 'From start to published memorial, everything designed to be simple, beautiful and meaningful.',
        footer: 'Creating the memorial is free · You only pay if you want to publish',
        step: 'Step',
        steps: [
          {
            num: '01',
            label: 'Create the memorial',
            title: 'Create the memorial',
            subtitle: 'How to fill it in?',
            description: 'Fill in the tribute information: personal details, a special phrase, biography, photos and even audio. All in a simple and caring way.',
            cta: 'Start now',
          },
          {
            num: '02',
            label: 'See the result',
            title: 'See the result',
            subtitle: 'What does the memorial look like?',
            description: 'The memorial is displayed ready on screen for you to see how it turned out. It is saved in your profile, ready to be published when you decide.',
            cta: 'See example',
          },
          {
            num: '03',
            label: 'Choose a plan',
            title: 'Choose a plan',
            subtitle: 'How to publish?',
            description: 'If you like the result, choose a plan to publish the memorial online and/or receive the physical QR Code plaque for the graveside.',
            cta: 'See plans',
          },
        ],
      },

      plans: {
        eyebrow: 'Plans',
        title: 'Choose Your Plan',
        description: 'Two options to eternalize the memory of those you love',
        choosePlan: 'CHOOSE PLAN',
        digital: 'Digital Plan',
        digitalPrice: 'R$ 29.90',
        digitalDesc: 'Digital memorial published on the platform',
        digitalFeatures: [
          'Complete digital memorial',
          'Gallery of up to 10 photos',
          'Tribute audio',
          'Digital QR Code',
        ],
        plaque: 'QR Code Plaque Plan',
        plaquePrice: 'R$ 149.90',
        plaqueDesc: 'Memorial + Physical stainless steel plaque',
        plaqueFeatures: [
          'Everything in the Digital Plan',
          'Physical stainless steel plaque',
          'Permanently engraved QR Code',
          'Shipping across Brazil',
        ],
        mostPopular: 'Most Popular',
        complete: 'Complete Plan',
        completeDesc: 'Memorial + Physical Plaque',
        editFee: 'Future edit fee',
        paymentSafe: 'Secure payment via',
      },

      showcase: {
        eyebrow: 'Physical product',
        title: 'See how your tribute\ncomes to life',
        description: 'After sharing your loved one\'s story, we create a unique physical tribute — crafted with care to preserve memories forever.',
        badge1: 'Engraved stainless steel',
        badge2: 'QR Code',
        mainLabel: 'Final product photo',
        card1: 'Finish detail',
        card2: 'How it arrives packaged',
        card3: 'Example of a finished tribute',
        benefit1Title: 'Made with care and respect',
        benefit1Desc: 'Every piece is crafted with attention to detail and what it represents.',
        benefit2Title: 'High-quality material',
        benefit2Desc: 'Time-resistant stainless steel, preserving the memory for decades.',
        benefit3Title: 'An eternal keepsake for the family',
        benefit3Desc: 'A physical place to honor and remember those who have passed.',
        cta: 'Start my tribute',
        ctaFooter: 'Creating is free · Save as draft and finish at your own pace · You only pay when you publish',
        imgSoon: 'Real product photo coming soon',
        imgInsert: 'Insert photo here',
        products: [
          {
            name: 'Engraved to last forever',
            subtitle: 'Stainless steel with precision laser',
          },
          {
            name: 'Every detail tells a story',
            subtitle: 'Premium finish, crafted with care',
          },
          {
            name: 'Ready to move hearts',
            subtitle: 'Delivered with love, done right',
          },
        ],
      },

      trust: {
        secure: 'Secure Site',
        payment: 'Payment via Mercado Pago',
        delivery: 'Trackable Delivery',
      },

      faq: {
        eyebrow: 'FAQ',
        title: 'All the answers.',
        description: 'Have a question? The answer is here.',
        items: [
          {
            q: 'How does the QR Code work?',
            a: 'The QR Code is engraved on a durable stainless steel plaque. When scanned with a smartphone, it automatically directs to the digital memorial of the honored person.',
          },
          {
            q: 'Is the memorial available forever?',
            a: 'Yes! After creation and payment, your memorial is permanently hosted on our platform, accessible 24/7 from anywhere in the world.',
          },
          {
            q: 'Can I edit the memorial after it is created?',
            a: "Yes! After purchasing a plan, you can edit your memorial for free at any time. Just go to the 'My Memorials' page and click the edit button on the memorial card.",
          },
          {
            q: 'How long does plaque delivery take?',
            a: 'Production and shipping take 7 to 15 business days. You will receive a tracking code as soon as the order is dispatched.',
          },
          {
            q: 'Does the plaque withstand weather conditions?',
            a: 'Yes! Our plaque is made of high-quality stainless steel, resistant to rain, sun, and temperature changes, ensuring durability for many years.',
          },
        ],
      },

      testimonials: {
        eyebrow: 'Reviews',
        title: 'What our customers say',
        close: 'Close',
        review: 'Review',
        client: 'Customer',
        prev: 'Previous',
        next: 'Next',
        review_n: 'Review {{n}}',
      },

      why: {
        eyebrow: 'Why choose us',
        title: 'Why\nRemember QRCode.',
        description: 'Choose those who understand the importance of preserving memories. We offer a unique QR Code technology that connects the present to the past in a meaningful way.',
        cta: 'About Remember QRCode',
      },

      memorial: {
        createTitle: 'Create Memorial',
        step1: 'Person Data',
        step2: 'Memorial Content',
        step3: 'Responsible Data',
        fullName: 'Full Name',
        relationship: 'Relationship',
        birthCity: 'Birth City',
        birthState: 'Birth State',
        deathCity: 'Death City',
        deathState: 'Death State',
        photo: 'Main Photo',
        publicMemorial: 'Show in explore',
        mainPhrase: 'Main Phrase',
        biography: 'Biography',
        gallery: 'Photo Gallery',
        audio: 'Audio',
        responsibleName: 'Responsible Name',
        phone: 'Phone',
        next: 'Next',
        back: 'Back',
        finish: 'Finish',
        selectPlan: 'Select Plan',
        notFound: 'Memorial not found',
        notFoundDesc: 'This memorial may have been removed or the link is incorrect. Check the address and try again.',
        exploreBtn: 'Explore memorials',
        loading: 'Loading memorial…',
        birthDate: 'Birth Date',
        deathDate: 'Death Date',
        birthState: 'State',
        deathState: 'State',
        stepLabel: 'Step {{step}} of 3',
        heroEyebrow: 'An eternal tribute',
        step1Label: 'Details',
        step2Label: 'Content',
        step3Label: 'Responsible',
        photoReady: 'Photo cropped and ready',
        photoChange: 'Change photo',
        photoRemove: 'Remove',
        photoTap: 'Tap to upload a photo',
        photoCrop: 'You can crop after selecting',
        galleryTap: 'Tap to add photos ({{count}}/10)',
        audioTap: 'Tap to upload audio',
        audioDetail: 'Optional',
        privacyNote: 'Your information is handled with full privacy and used only to contact you about the memorial.',
        saving: 'Saving...',
        processing: 'Processing...',
        relationshipPlaceholder: 'E.g.: Father, Mother, Grandfather, Friend...',
        mainPhrasePlaceholder: 'A special message to honor...',
        biographyPlaceholder: 'Tell the life story, special moments, remarkable characteristics...',
        galleryCount: 'Up to 10 photos',
        inMemoryOf: 'In memory of',
        lifeStory: 'Life Story',
        noStory: 'No story registered.',
        noPhotos: 'No photos in gallery',
        tributeMessage: 'Tribute Message',
        noAudio: 'No audio registered',
        createdWithLove: 'Created with love by {{name}}',
        tab_historia: 'History',
        tab_memorias: 'Memories',
        tab_audio: 'Audio',
        tab_condolencias: 'Condolences',
      },

      selectPlan: {
        eyebrow: 'Publish memorial',
        title: 'Choose Your Plan',
        description: 'Select the ideal plan to eternalize the memories',
        affiliateLabel: 'Have an affiliate code?',
        affiliatePlaceholder: 'E.g.: JOAO2024',
        applyBtn: 'Apply',
        codeApplied: 'Code {{code}} applied',
        codeDiscount: '{{pct}}% discount on chosen plan',
        recommended: 'Recommended',
        oneTimePayment: 'One-time payment',
        selectBtn: 'Select Plan',
        processing: 'Processing...',
        plans: [
          {
            id: 'digital',
            name: 'Digital Plan',
            price: 29.90,
            features: [
              'Complete digital memorial',
              'Gallery of up to 10 photos',
              'Tribute audio',
              'Digital QR Code',
              'Instant publishing',
              'Eternal hosting',
            ],
          },
          {
            id: 'plaque',
            name: 'QR Code Plaque Plan',
            price: 149.90,
            features: [
              'Everything in the Digital Plan',
              'Physical stainless steel plaque',
              'Permanently engraved QR Code',
              'Shipping across Brazil',
              'Priority support',
              'Delivery tracking',
            ],
          },
        ],
      },

      condolences: {
        title: 'Condolences',
        thankYou: 'Your message was sent. Thank you for honoring',
        viewMessages: 'View messages',
        sendCondolence: 'Send condolence',
        noMessages: 'No messages yet',
        beFirst: 'Be the first to leave a tribute for {{name}}.',
        step1: '1 · Choose or write your message',
        step2: '2 · Who is sending?',
        sendAnonymous: 'Send anonymously',
        anonymousDesc: 'Your identity will not be displayed',
        yourName: 'Your name',
        yourNamePlaceholder: 'What is your name?',
        youAre: 'You are (optional)',
        minChars: '{{count}} / min. 10 characters',
        sending: 'Sending...',
        sendBtn: 'Send my condolence',
        writeMessage: 'Write your message from the heart...',
        anonymous: 'Anonymous',
        showLess: 'Show less ↑',
        showMore: 'Show more ↓',
        relations: {
          familia: 'Family member',
          amigo: 'Friend',
          colega: 'Colleague',
          vizinho: 'Neighbor',
          outro: 'Other',
        },
        presets: [
          { short: 'Peace and comfort', text: 'May peace and comfort be with you in this difficult moment. You are in our thoughts and prayers.' },
          { short: 'Longing with love', text: 'May longing always be a form of love. I will cherish every memory alongside this special person.' },
          { short: 'Strength and faith', text: 'May God comfort your hearts and may the memory of happy moments bring light in the darkest days.' },
          { short: 'Eternal life', text: 'Such a special life leaves eternal marks on all who had the privilege of knowing them. May they rest in peace.' },
          { short: 'Always with us', text: 'Those who leave with kindness in their heart never truly disappear — they live in every smile and every memory.' },
          { short: 'My own message', text: '' },
        ],
      },

      review: {
        loginRequired: 'Please log in to leave your review',
        successTitle: 'Review submitted successfully!',
        successDesc: 'Thank you for your feedback. Your review will be checked and published soon.',
        eyebrow: 'Review',
        title: 'Leave your Review',
        ratingLabel: 'Your rating *',
        titleLabel: 'Title (optional)',
        titlePlaceholder: 'E.g.: Excellent service!',
        commentLabel: 'Comment (optional)',
        commentPlaceholder: 'Tell us about your experience with the platform...',
        sending: 'Sending...',
        sendBtn: 'Submit Review',
        ratings: { 1: 'Poor', 2: 'Fair', 3: 'Good', 4: 'Very good!', 5: 'Excellent!' },
      },

     qrModal: {
        titlePrint: 'QR Code for Printing',
        titleDefault: 'Memorial QR Code',
        formatPng: 'PNG (high resolution)',
        formatPdf: 'PDF (5×5cm — print shop)',
        formatSvg: 'SVG (vectorized)',
        infoPng: '🖨️ <strong>{{size}}×{{size}}px</strong> — ready for 5×5cm engraving',
        infoPdf: '📄 <strong>PDF 50×50mm</strong> — ready to send to print shop',
        infoSvg: '📐 <strong>SVG vectorized</strong> — infinite scale, ideal for print shop',
        infoPreview: '🔍 Preview — admin downloads in high resolution (1200px)',
        copy: 'Copy link',
        copied: 'Copied!',
        downloadPng: 'Download PNG (1200px)',
        downloadPngDefault: 'Download PNG',
        downloadPdf: 'Download PDF (50×50mm)',
        downloadSvg: 'Download SVG (print shop)',
        plateLabel: 'A life, many memories.',
      },

      footer: {
        tagline: 'Digital memorials to preserve stories and honor lives.',
        followUs: 'Follow us',
        colProduct: 'Product',
        colCompany: 'Company',
        colSupport: 'Support',
        colGuarantees: 'Guarantees',
        emailLabel: 'Email',
        chatLabel: 'Chat',
        chatLink: 'Chat on WhatsApp',
        guarantee1: 'Secure Purchase',
        guarantee2: 'Trackable Delivery',
        guarantee3: 'Dedicated Support',
        copyright: '© {{year}} Remember QRCode · All rights reserved.',
        about: 'About Remember QRCode',
        responsibility: 'Responsibility Policy',
        privacy: 'Privacy Policy',
        returns: 'Exchanges, Returns & Refunds',
        terms: 'Terms and Conditions',
        delivery: 'Delivery Policy',
        aboutShort: 'About us',
        privacyShort: 'Privacy',
        cancellation: 'Cancellation & Refund',
      },

      security: {
        secure: '100% Secure Purchase',
        redirectMessage: 'You will be redirected to secure payment via',
        paymentSafe: 'Secure payment via',
        secureEnv: 'Secure environment',
        ssl: 'SSL 256-bit',
        paymentVia: 'Payment via',
      },

      // ── Payment ──────────────────────────────────────────────────────────────
      payment: {
        eyebrow: 'Payment',
        title: 'Complete Your Payment',
        subtitle: 'Scan the Pix QR Code to pay',
        qrUnavailable: 'QR Code unavailable',
        instructionsLabel: 'Instructions',
        instructions: [
          'Open your banking app',
          'Choose the Pix option',
          'Scan the QR Code above',
          'Confirm the payment',
        ],
        waitingConfirmation: 'Waiting for payment confirmation...',
      },

      // ── Payment Success ──────────────────────────────────────────────────────
      paymentSuccess: {
        title: 'Payment Approved!',
        description: 'Your memorial has been successfully published and is now available.',
        paymentId: 'Payment ID: {{id}}',
        btnMemorials: 'View My Memorials',
        btnHome: 'Back to Home',
      },

      // ── Payment Failure ──────────────────────────────────────────────────────
      paymentFailure: {
        title: 'Payment Not Completed',
        description: 'The payment was not completed. You can try again.',
        btnTryAgain: 'Try Again',
        btnHome: 'Back to Home',
      },

      // ── Payment Pending ──────────────────────────────────────────────────────
      paymentPending: {
        title: 'Payment Pending',
        description: 'We are waiting for your payment confirmation. Once approved, your memorial will be published automatically.',
        notice: 'You will receive a notification when the payment is confirmed. This may take a few minutes.',
        btnMemorials: 'View My Memorials',
        btnHome: 'Back to Home',
      },

      howItWorksHero: {
        eyebrow: 'How It Works',
        titleLine1: 'That simple.',
        titleLine2: '3 steps, eternal.',
        description: 'Creating an eternal memorial is simple, fast and made with great care. In just 3 steps you honor those you love.',
        cta: 'Create free memorial',
        badge1: '✦ Step 01 — Create',
        badge2: '✦ Step 02 — Preview',
        badge3: '✦ Step 03 — Publish',
      },

      includedSection: {
        eyebrow: 'Details',
        title: "What's",
        titleItalic: 'included?',
        items: [
          { title: 'Complete Digital Memorial', desc: 'Personalized page with photos, biography and audio' },
          { title: 'Unique QR Code', desc: 'Instant access to the memorial from anywhere' },
          { title: 'Photo Gallery', desc: 'Up to 10 images to preserve special moments' },
          { title: 'Stainless Steel Plaque (Optional)', desc: 'Durability and elegance to eternalize the tribute' },
          { title: 'Eternal Hosting', desc: 'Your memorial stays available forever' },
          { title: 'Dedicated Support', desc: 'WhatsApp support for any questions' },
        ],
      },

      stepsSection: {
        eyebrow: 'The Process',
        title: 'Create, preview and publish.',
        description: `Fill it out, see the result, and choose a plan.
        If you're not finished right now, save it as a draft and continue later.`,
        descriptionMobile: `Create at your own pace.
        Save and continue whenever you want.`,
        stepLabel: 'STEP',
        steps: [
          {
            number: '01',
            title: 'Create the Memorial',
            description: 'Fill in the information about the honored person with care: personal details, a special phrase, biography, photo gallery and even a tribute audio. All in a simple and guided way, so you can express all the love you feel.',
            highlight: 'Creating is free',
            cta: 'Start now',
          },
          {
            number: '02',
            title: 'See the Result',
            description: 'As soon as you finish, the memorial will be displayed ready on screen for you to preview. See how the complete tribute looks, check every detail and feel the result. The memorial is saved in your profile, ready for when you decide to publish.',
            highlight: 'Instant preview',
            cta: 'See example',
          },
          {
            number: '03',
            title: 'Choose a Plan',
            description: 'If you like the result, choose the plan that best suits your needs: the Digital Plan to publish the memorial online, or the QR Code Plaque Plan to also receive a physical stainless steel plaque with an engraved QR Code to place at the graveside.',
            highlight: 'Only pay if you want to publish',
            cta: 'See plans',
          },
        ],
      },

      ctaSection: {
        eyebrow: 'Ready to start?',
        titleLine1: 'Create now,',
        titleLine2: 'for free.',
        cta: 'Start Now',
      },

      whyPreservePage: {
        hero: {
          dates: '1948 · 2024',
          title: 'How many of your great-grandparents\' stories do you really know?',
          description: 'A gravestone shows only a name and two dates. But between those dates lies an entire life — stories, achievements, love and memories that deserve to be preserved forever.',
          ticker: ['childhood · ', 'love · ', 'achievements · ', 'family · ', 'adventures · ', 'legacy · ', 'friendships · ', 'faith · '],
          cta: 'Create a memorial',
          ctaSecondary: 'See examples',
        },
        problem: {
          eyebrow: 'The real problem',
          title: 'Memories fade.\nSilently. Forever.',
          description: 'Most families only realize when it\'s too late. When that story only grandpa knew how to tell… no longer exists.',
          stat: '"A large part of family stories is lost after just a few generations."',
          cards: [
            { title: 'Stories that were never recorded', text: 'Every person who passes takes with them secrets, tales and wisdom that no one had time to preserve.' },
            { title: 'Generations that never meet', text: 'Your grandchildren will grow up not knowing who their ancestors were and what made them special.' },
            { title: 'Memory fades with time', text: 'In less than 3 generations, an entire life disappears. In 75 years, only the dates remain.' },
          ],
        },
        meaning: {
          eyebrow: 'What is a memorial',
          quote: '"It\'s not just a page.\nIt\'s an act of love that lasts forever."',
          description: 'A digital memorial is the decision not to let time erase a life. It\'s choosing that story to keep being told.',
          pillars: [
            { title: 'A legacy', desc: 'What a person built throughout an entire lifetime, preserved and passed on to future generations.' },
            { title: 'A tribute', desc: 'The most beautiful way to say that a life mattered. That that person made a difference. That they are loved.' },
            { title: 'An eternal memory', desc: 'No matter how much time passes. The love recorded in a memorial never fades. Never disappears.' },
          ],
        },
        whatIs: {
          eyebrow: 'The product',
          title: 'What exists inside\na digital memorial',
          description: 'Much more than a page. A place where an entire life is preserved, revisited and loved.',
          browserUrl: 'remember.com.br/memorial/joao-silva',
          browserName: 'João Silva',
          browserDates: '1948 – 2024',
          browserQuote: '"A family man, devoted father, friend forever remembered by all who had the privilege of knowing him..."',
          features: [
            { title: 'Life story', desc: 'A complete biography with the most important moments, written with care by the family.' },
            { title: 'Photo gallery', desc: 'Dozens of organized photos, accessible from any phone with a simple scan.' },
            { title: 'Tribute audio', desc: 'A special song, a prayer or voice message that represents the person who passed.' },
            { title: 'Family messages', desc: 'Family and friends can leave eternal messages of love, longing and gratitude.' },
            { title: 'Special moments', desc: 'Dates, achievements and life milestones recorded in a visual and emotional way.' },
            { title: 'QR Code at the graveside', desc: 'A stainless steel plaque with QR Code that connects visitors to the digital memorial.' },
          ],
        },
        moments: {
          eyebrow: 'Each life',
          title: 'Think of all the moments\nthat make up a life.',
          description: 'Each one is unique. Each one deserves to be remembered. And now, all of them can be preserved.',
          items: [
            { key: 'infancia', label: 'Childhood', desc: 'The first memories, games and discoveries that shaped who they were.' },
            { key: 'amor', label: 'Love', desc: 'Encounters, marriages and the bonds that defined an entire lifetime.' },
            { key: 'conquistas', label: 'Achievements', desc: 'Graduation, career and the dreams that one day became reality.' },
            { key: 'familia', label: 'Family', desc: 'The children, grandchildren and generations that came after and carry their legacy.' },
            { key: 'aventuras', label: 'Adventures', desc: 'Travels, new discoveries and experiences they chose to live.' },
            { key: 'fe', label: 'Faith', desc: 'The beliefs and spiritual values that guided every step of life.' },
            { key: 'amizade', label: 'Friendships', desc: 'The true friends who stood by their side in the most important moments.' },
            { key: 'legado', label: 'Legacy', desc: 'What they left in the world: love, inspiration and difference.' },
          ],
        },
        howItWorks: {
          eyebrow: 'Process',
          title: 'In 4 simple steps,\nan eternal legacy.',
          description: 'Designed to be simple, beautiful and meaningful. From start to published memorial.',
          stepLabel: 'Step',
          footer: 'Creating the memorial is free · You only pay if you want to publish',
          steps: [
            { n: '01', title: 'Create the memorial', desc: 'Fill in the name, dates, life story, photos and special moments. All simple and guided.' },
            { n: '02', title: 'Add memories', desc: 'Upload photos, audios and messages. The gallery is built automatically in a beautiful and emotional way.' },
            { n: '03', title: 'Receive the QR Code plaque', desc: 'After choosing a plan, you receive a stainless steel plaque with permanently engraved QR Code.' },
            { n: '04', title: 'Family accesses forever', desc: 'Anyone with a phone can scan and access the memorial. Forever. From anywhere.' },
          ],
        },
        beforeAfter: {
          eyebrow: 'The transformation',
          title: 'What changes with a\ndigital memorial',
          description: 'A simple decision. A difference that lasts forever.',
          beforeLabel: 'Without memorial',
          beforeTitle: 'The memory is lost',
          afterLabel: 'With digital memorial',
          afterTitle: 'The memory lives forever',
          cta: 'Create memorial now — it\'s free',
          beforeItems: [
            'Photos kept in boxes and drawers',
            'Stories lost forever',
            'Family remembering less and less',
            'A life erased with the passage of time',
            'Children who will never truly know their grandfather',
            'Voice, personality and laughter forgotten',
          ],
          afterItems: [
            'Digital memorial accessible from anywhere',
            'Complete life story preserved',
            'Family reconnected to memories at any time',
            'Children and grandchildren knowing the family legacy',
            'Memories preserved for future generations',
            'QR Code at graveside connects physical and digital',
          ],
        },
        testimonials: {
          eyebrow: 'Reviews',
          title: 'What families say',
          description: 'Real stories from those who chose to preserve forever.',
          items: [
            { name: 'Maria Souza', role: 'Daughter', text: 'Now my grandchildren can know the story of their great-grandfather. The memorial has become a family treasure.' },
            { name: 'João Carlos', role: 'Son', text: 'The QR Code on my father\'s gravestone is priceless. Every visit has become special in a different way.' },
            { name: 'Ana Paula', role: 'Granddaughter', text: 'I created the memorial for my grandmother and the whole family was moved. It felt like she was present again.' },
          ],
        },
        finalCta: {
          eyebrow: 'Start now',
          title: 'Create a memorial that\nlasts forever.',
          description: 'Don\'t wait for time to erase the memories. Preserve today the story of those you love — so future generations can know, love and be proud of where they came from.',
          cta: 'Create free memorial',
          ctaSecondary: 'See memorial examples',
          stats: [
            { n: '100%', label: 'Free to create' },
            { n: '∞', label: 'Available forever' },
            { n: '24/7', label: 'Accessible from anywhere' },
          ],
        },
      },

      explore: {
        eyebrow: 'Stories that live on',
        title: 'Explore',
        titleItalic: 'Memorials',
        description: 'Eternal tributes that preserve memories and stories of special lives.',
        empty: 'No memorials yet',
        emptyDesc: 'Be the first to create a memorial and share a life story.',
        viewMemorial: 'View memorial',
        loading: 'Loading...',
        loadMore: 'Load more ({{count}} remaining)',
      },

      preview: {
        successTitle: 'Memorial created successfully!',
        successDesc: 'See below how your tribute looks. Choose a plan to publish.',
        draftMode: 'Preview mode — Draft',
        choosePlan: 'Choose Plan',
        createOther: 'Create another',
        footer: 'Creating is free · Pay only when publishing',
      },

      edit: {
        eyebrow: 'Edit memorial',
        published: 'Published',
        draft: 'Draft',
        back: 'Back',
        cancel: 'Cancel',
        save: 'Save changes',
        saving: 'Saving...',
        photoCard: 'Photo of the Honored',
        photoUpload: 'Click to upload photo',
        photoChange: 'Click to change photo',
        photoUploading: 'Uploading...',
        personalCard: 'Personal Details',
        visibilityCard: 'Visibility in Explore',
        visibleLabel: 'Visible in Explore',
        hiddenLabel: 'Hidden from Explore',
        visibleDesc: 'Anyone can find this memorial',
        hiddenDesc: 'Only those with the link can access it',
        visibilityNote: '💡 Regardless of this setting, anyone with the direct memorial link will be able to visit it.',
        contentCard: 'Memorial Content',
        galleryCard: 'Memory Gallery',
        galleryUpload: 'Add photos to gallery',
        audioCard: 'Tribute Audio',
        audioUpload: 'Upload tribute audio',
        audioRemove: 'Remove audio',
      },

      institutional: {
        about: {
          heroTag: 'About us',
          heroTitle: 'We were born to preserve what matters most.',
          heroSubtitle: 'Remember QRCode is a Brazilian platform dedicated to creating permanent digital memorials, connecting life stories to the present through technology.',
          whoWeAreTitle: 'Who we are',
          whoWeAre1: 'Remember QRCode is a Brazilian company created with the purpose of transforming the way we honor and remember the people we love. We believe every life deserves to be told, celebrated and preserved for future generations.',
          whoWeAre2: 'We combine accessible technology with a high-quality physical product — the stainless steel plaque with QR Code — to create a permanent bridge between the physical and digital worlds.',
          missionTitle: 'Our mission',
          mission: 'To offer families a dignified, accessible and lasting way to preserve the memory of their loved ones, with respect, simplicity and care at every step of the process.',
          visionTitle: 'Our vision',
          vision: 'To be the leading digital memorial platform in Brazil, recognized for product quality, humanized service and the positive impact we generate for Brazilian families.',
          valuesTitle: 'Our values',
          values: [
            { icon: '🤍', title: 'Respect and empathy', text: 'Each memorial is unique. We treat every story with the care and sensitivity it deserves.' },
            { icon: '🔒', title: 'Trust and security', text: 'Your data and the created memorial are stored securely and remain permanently available.' },
            { icon: '✨', title: 'Simplicity', text: 'We create a simple and intuitive experience so anyone can build a beautiful memorial.' },
            { icon: '🌐', title: 'Technology with purpose', text: "We use technology not for trend's sake, but to create something with real meaning for families." },
          ],
          howItWorksTitle: 'How it works',
          howItWorks1: 'Anyone can create a digital memorial for free on our platform. After creation, the memorial is saved as a draft, allowing revisions before publication.',
          howItWorks2: 'When satisfied, the customer can choose between the <strong>Digital Plan</strong> — which publishes the memorial online with an exclusive link and QR Code — or the <strong>QR Code Plaque Plan</strong>, which includes the production and delivery of a physical stainless steel plaque for placement on graves, vaults or memorial sites.',
          affiliatesTitle: 'Partnership with funeral homes and cemeteries',
          affiliates: 'We have an affiliate program aimed at funeral homes and cemeteries. Partners receive an exclusive code that offers discounts to customers and generates progressive commission on sales. Contact us to learn more.',
          cta: 'Create free memorial',
        },

        delivery: {
          heroTag: 'Delivery',
          heroTitle: 'Delivery Policy',
          heroSubtitle: 'Everything you need to know about deadlines, shipping methods and order tracking.',
          s1Title: '1. Delivery coverage',
          s1: 'Remember QRCode delivers across the entire national territory. Physical plaque shipping is done exclusively after payment confirmation and client approval of the memorial.',
          s2Title: '2. Production and shipping timeline',
          s2Intro: 'After payment confirmation, the order follows these steps:',
          s2Items: [
            '<strong>Plaque production:</strong> up to 5 business days.',
            '<strong>Dispatch to carrier:</strong> within 2 business days after completion.',
            '<strong>Delivery to recipient:</strong> 3 to 8 business days after dispatch, depending on the region.',
          ],
          s2Footer: 'The estimated total timeframe is <strong>7 to 15 business days</strong> from payment confirmation. More remote regions may have longer timelines.',
          s3Title: '3. Order tracking',
          s3a: 'Once the order is dispatched, the customer will receive an email with the tracking code and a link to follow the delivery directly on the carrier\'s website.',
          s3b: 'All status updates are also sent by email throughout the process:',
          s3Items: [
            'Memorial created and payment confirmed.',
            'Order in production.',
            'Product finalized and being prepared for shipping.',
            'Order dispatched (with tracking code).',
            'Order delivered.',
          ],
          s4Title: '4. Shipping fee',
          s4: 'The shipping fee is calculated automatically at the time of purchase, based on the delivery zip code provided by the customer. The value is displayed clearly before order completion.',
          s5Title: '5. Delivery address',
          s5a: 'The customer is responsible for providing the correct delivery address. In case of incorrect or incomplete address, Remember QRCode is not liable for delays or non-delivery.',
          s5b: 'If you need to correct the address after order confirmation, contact our team immediately via WhatsApp or email. Changes can only be made if the order has not yet been dispatched.',
          s6Title: '6. Delivery attempts',
          s6a: 'The carrier will make up to 3 delivery attempts at the provided address. If no one is available to receive it, the customer will be directed to pick up the package at a nearby collection point, per the carrier\'s guidelines.',
          s6b: 'After the holding period at the collection point, the package may be returned to sender. In that case, a new shipment may be arranged upon payment of a new shipping fee.',
          s7Title: '7. Damage or loss',
          s7a: 'In case of damage or loss during transport, the customer must contact our team within <strong>7 days of the expected delivery date</strong>, providing photos of the received product (if damaged) or reporting the absence of delivery.',
          s7b: 'After review, we will arrange the production and reshipment of a new plaque at no additional cost to the customer.',
          s8Title: '8. Delivery questions',
          s8: 'For any questions about your order shipment, contact our team via WhatsApp (+55 22 99208-0811) or email (rememberqrcode@gmail.com). We respond within 1 business day.',
        },

        privacy: {
          heroTag: 'Privacy',
          heroTitle: 'Privacy Policy',
          heroSubtitle: 'Learn how we collect, use and protect your personal information at Remember QRCode.',
          s1Title: '1. What data we collect',
          s1Intro: 'When using our platform, we may collect the following information:',
          s1Items: [
            '<strong>Registration data:</strong> name, email and password (encrypted).',
            '<strong>Memorial data:</strong> name, photo, biography, dates and other information voluntarily entered by the user.',
            '<strong>Payment data:</strong> fully processed by certified gateways (we do not store card data).',
            '<strong>Delivery data:</strong> address provided for physical plaque shipping.',
            '<strong>Navigation data:</strong> cookies and technical access data (IP, browser, device), used exclusively to improve the platform.',
          ],
          s2Title: '2. How we use your data',
          s2Intro: 'Collected data is used exclusively to:',
          s2Items: [
            'Create and manage your account and associated memorials.',
            'Process payments and issue purchase confirmations.',
            'Send order updates by email (production, dispatch, delivery).',
            'Provide customer support when requested.',
            'Continuously improve the platform experience.',
          ],
          s2Footer: '<strong>We do not sell, rent or share your personal data with third parties</strong> for commercial or advertising purposes.',
          s3Title: '3. Storage and security',
          s3a: 'All data is stored on secure encrypted servers. We adopt adequate technical and administrative measures to protect your information against unauthorized access, loss or leakage.',
          s3b: 'User passwords are stored with cryptographic hashing and can never be directly accessed by any company employee.',
          s4Title: '4. Data sharing',
          s4Intro: 'Your data may only be shared in the following situations:',
          s4Items: [
            '<strong>Carriers:</strong> name and delivery address, exclusively for physical plaque delivery.',
            '<strong>Payment gateway:</strong> data required for transaction processing.',
            '<strong>Legal obligations:</strong> when required by law or competent authority.',
          ],
          s5Title: '5. Your rights (LGPD)',
          s5Intro: 'In accordance with the General Data Protection Law (Law No. 13,709/2018), you have the right to:',
          s5Items: [
            'Confirm the existence of processing of your data.',
            'Access the data we hold about you.',
            'Correct incomplete or outdated data.',
            'Request the deletion of your personal data.',
            'Revoke previously given consent.',
          ],
          s5Footer: 'To exercise any of these rights, contact our team via the email or WhatsApp available in the site footer.',
          s6Title: '6. Cookies',
          s6: 'We use strictly necessary cookies for platform operation and analytical cookies to understand how users navigate the site. You can disable cookies in your browser, though this may affect some features.',
          s7Title: '7. Data retention',
          s7: 'Data is retained while your account is active. After account deletion, personal data is removed within 30 days, except data required by legal or tax obligations.',
          s8Title: '8. Policy updates',
          s8a: 'This policy may be updated periodically. In case of relevant changes, registered users will be notified by email. The date of last update will always be indicated at the bottom of this page.',
          s8Date: 'Last updated: June 2025.',
        },

        terms: {
          heroTag: 'Legal',
          heroTitle: 'Terms and Conditions',
          heroSubtitle: 'Please read the terms of use of the Remember QRCode platform carefully before using our services.',
          s1Title: '1. Acceptance of terms',
          s1: 'By creating an account, using the platform or purchasing any product or service from Remember QRCode, the user declares that they have read, understood and agree to these Terms and Conditions of Use. If you do not agree with any provision, we recommend that you do not use the platform.',
          s2Title: '2. Description of services',
          s2Intro: 'Remember QRCode offers:',
          s2Items: [
            'Free creation of digital memorials in draft format.',
            'Official online memorial publication upon contracting the Digital Plan.',
            'Production and delivery of a physical stainless steel plaque with QR Code, upon contracting the QR Code Plaque Plan.',
          ],
          s3Title: '3. User registration and account',
          s3a: 'To use the platform, you must create an account with true and up-to-date information. The user is responsible for the confidentiality of their password and all activities carried out on their account.',
          s3b: 'Remember QRCode reserves the right to suspend or delete accounts that violate these terms, contain false information or exhibit abusive behavior on the platform.',
          s4Title: '4. Memorial content',
          s4Intro: 'The user is fully responsible for the content entered in memorials. It is strictly prohibited to publish content that:',
          s4Items: [
            'Is false, misleading or defamatory.',
            'Violates copyright, image rights or privacy of third parties.',
            'Contains offensive, discriminatory, violent or illegal material.',
            'References living persons without explicit authorization.',
          ],
          s4Footer: 'Remember QRCode may remove any content that violates these guidelines, without prior notice and without right to refund.',
          s5Title: '5. Payments and plans',
          s5a: 'Plan prices are those in effect at the time of contracting. Payment is processed by certified and secure gateways. After payment confirmation, the order enters processing immediately.',
          s5b: 'We do not offer installments outside the conditions provided by the payment gateway. Promotions and discounts (including those generated by affiliate codes) are not cumulative.',
          s6Title: '6. Delivery timeline',
          s6a: 'The production and delivery timeframe for the physical plaque is 7 to 15 business days after payment confirmation. The customer will receive the tracking code by email once the order is dispatched.',
          s6b: 'Delays caused by carriers, strikes, natural disasters or other events outside the company\'s control do not generate the right to automatic refund, but will be communicated to the customer.',
          s7Title: '7. Digital memorial availability',
          s7: 'Published memorials remain permanently available on the platform, except in cases of violation of these terms or express request by the account holder. Remember QRCode will make all reasonable efforts to keep the platform available 24 hours a day, 7 days a week.',
          s8Title: '8. Affiliate program',
          s8a: 'Funeral homes, cemeteries and other partners can participate in the affiliate program upon formal enrollment. The partner receives an exclusive code that generates discounts for customers and progressive commission (10%, 15% or 20%) on sales made with the code.',
          s8b: 'Commissions are calculated monthly and paid as agreed in the partnership contract. Remember QRCode reserves the right to terminate partnerships that violate the platform\'s ethical principles.',
          s9Title: '9. Intellectual property',
          s9: 'All platform content — brand, logo, design, institutional texts and code — is the exclusive property of Remember QRCode and protected by law. Reproduction, copying or unauthorized use of any platform element is prohibited.',
          s10Title: '10. Limitation of liability',
          s10: 'Remember QRCode is not liable for indirect damages, lost profits or losses resulting from use of the platform, except in cases expressly provided by law. Our liability is limited to the amount paid by the customer for the contracted service.',
          s11Title: '11. Changes to terms',
          s11: 'These Terms and Conditions may be updated at any time. Registered users will be notified by email of relevant changes. Continued use of the platform after notification implies acceptance of the new terms.',
          s12Title: '12. Jurisdiction and applicable law',
          s12a: 'These terms are governed by Brazilian law. In case of conflict, the parties elect the jurisdiction of the consumer\'s domicile, as provided by the Consumer Protection Code.',
          s12Date: 'Last updated: June 2025.',
        },

        responsibility: {
          heroTag: 'Policy',
          heroTitle: 'Responsibility Policy',
          heroSubtitle: 'Learn about our commitments to you, to the memorials created and to the ethical conduct of our platform.',
          s1Title: '1. Our commitment',
          s1: 'Remember QRCode takes full responsibility for the quality of the services offered, the security of stored information and respect for the customer at every stage of the journey — from memorial creation to physical product delivery.',
          s2Title: '2. Responsibility for memorial content',
          s2a: 'The content entered in memorials — texts, photos, audio and other information — is the exclusive responsibility of the user who created it. Remember QRCode does not produce, edit or validate content published by customers.',
          s2Intro: 'By using the platform, the user declares that:',
          s2Items: [
            'They hold the rights to the images and information entered.',
            'The content does not violate third-party rights, applicable laws or codes of conduct.',
            'The information is truthful and refers to a real person.',
          ],
          s2Footer: 'Remember QRCode reserves the right to remove, without prior notice, any memorial containing offensive, illegal content or that violates the platform\'s Terms and Conditions.',
          s3Title: '3. Responsibility for the physical product',
          s3a: 'Remember QRCode is responsible for the production and delivery of physical plaques within the established timeframe (7 to 15 business days after payment confirmation). In case of manufacturing defect or transport damage, we commit to replacing the product at no additional cost to the customer.',
          s3Intro: 'We are not responsible for:',
          s3Items: [
            'Delays caused by carriers or external factors.',
            'Damage caused by improper use or incorrect installation of the plaque.',
            'Incorrect delivery address provided by the customer.',
          ],
          s4Title: '4. Responsibility for the digital service',
          s4a: 'We commit to keeping published memorials continuously available. In cases of scheduled maintenance or technical issues, we will notify customers in advance whenever possible.',
          s4b: 'The platform is not responsible for unavailability caused by third-party failures (internet providers, external servers, etc.).',
          s5Title: '5. Ethical conduct',
          s5: 'Remember QRCode does not use memorial information for commercial, advertising or personal data analysis purposes. All information is handled with confidentiality, respect and in compliance with the General Data Protection Law (LGPD).',
          s6Title: '6. Communication channel',
          s6: 'For questions, complaints or requests related to this policy, contact our team via WhatsApp or email available in the site footer. We respond within 2 business days.',
        },

        returns: {
          heroTag: 'Returns & Exchanges',
          heroTitle: 'Exchange, Return and Refund Policy',
          heroSubtitle: 'Full transparency about your rights and our procedures in cases of cancellation, defect or dissatisfaction.',
          s1Title: '1. Right of withdrawal',
          s1a: 'Under the Consumer Protection Code (Art. 49), the customer has the right to cancel the purchase within <strong>7 calendar days</strong> from the payment confirmation date, without need for justification.',
          s1b: 'Cancellation within this period guarantees a full refund, provided the physical product (plaque) has not been delivered to the customer.',
          s2Title: '2. How to request cancellation',
          s2Intro: 'To request cancellation within the legal timeframe, contact us through official channels:',
          s2Items: [
            'WhatsApp: +55 22 99208-0811',
            'Email: rememberqrcode@gmail.com',
          ],
          s2Footer: 'Provide your order number, registered email and reason for cancellation. Our team will confirm receipt of the request within 1 business day.',
          s3Title: '3. Refund timeline',
          s3Intro: 'After cancellation confirmation, the refund will be processed within <strong>10 business days</strong>, using the same payment method used for purchase:',
          s3Items: [
            '<strong>Credit card:</strong> reversal on the statement within 2 billing cycles (depending on the card issuer).',
            '<strong>PIX or bank slip:</strong> transfer to the account provided by the customer within 5 business days.',
          ],
          s4Title: '4. Exchange for manufacturing defect',
          s4Intro: 'If the physical plaque arrives with a visible defect, transport damage or discrepancy from the approved memorial, the customer must contact us within <strong>7 days of receipt</strong>, providing:',
          s4Items: [
            'Order number.',
            'Photo or video of the defect.',
            'Description of the problem.',
          ],
          s4Footer: 'After review, we will arrange the production and shipping of a new plaque at no additional cost to the customer.',
          s5Title: '5. Cases not covered by the exchange policy',
          s5Intro: 'We do not process exchanges or refunds in the following cases:',
          s5Items: [
            'Damage caused by improper use or incorrect installation of the plaque.',
            'Change of mind after delivery of the physical product.',
            'Errors in memorial information entered by the customer (verification is the customer\'s responsibility before approval).',
            'Cancellations requested after the legal 7-day period.',
          ],
          s6Title: '6. Digital Plan — cancellation',
          s6: 'For the Digital Plan, cancellation with refund is accepted within 7 calendar days, provided the memorial link has not been widely shared or publicly used in an irreversible way.',
          s7Title: '7. Questions',
          s7: 'Our team is available to clarify any questions related to this policy. Contact us via WhatsApp or email available in the site footer.',
        },
      },

      userPages: {
        dashboard: {
          eyebrow: 'User panel',
          title: 'Welcome,',
          subtitle: 'Manage your memorials and tributes',
          menu: [
            { title: 'My Memorials', description: 'View and manage your memorials' },
            { title: 'My Purchases', description: 'Order history and payments' },
            { title: 'My Account', description: 'Profile settings' },
          ],
          support: {
            title: 'Need Help?',
            subtitle: 'Contact our support team via WhatsApp',
            cta: 'Chat on WhatsApp',
          },
        },

        myMemorials: {
          eyebrow: 'User panel',
          title: 'My Memorials',
          createBtn: '+ Create New Memorial',
          emptyTitle: 'No memorials yet',
          emptyDesc: "You haven't created any memorials yet. Start preserving memories now.",
          emptyBtn: 'Create First Memorial',
          published: 'Published',
          draft: 'Draft',
          plan: 'Plan',
          actionView: 'View',
          actionEdit: '✏️ Edit',
          actionPublish: 'Publish',
          actionDelete: 'Delete draft',
          deleteModal: {
            title: 'Delete memorial?',
            about: 'You are about to delete the memorial of',
            warning: 'This action is permanent and cannot be undone. All photos, texts and settings will be erased.',
            cancel: 'Cancel',
            confirm: 'Delete',
            deleting: 'Deleting...',
          },
          toastSuccess: 'Memorial deleted successfully.',
          toastError: 'Error deleting memorial. Please try again.',
        },

        myPurchases: {
          eyebrow: 'User panel',
          title: 'My Purchases',
          emptyTitle: 'No purchases yet',
          emptyDesc: "You haven't made any purchases yet",
          order: 'Order',
          plan: 'Plan',
          mpId: 'Mercado Pago ID',
          refund: 'Refund within 7 business days',
          cancelRequested: 'Cancellation Requested',
          statuses: {
            approved: 'Approved',
            paid: 'Paid',
            pending: 'Pending',
            rejected: 'Rejected',
            in_process: 'Processing',
            in_production: 'In Production',
            produced: 'Produced',
            shipped: 'Shipped',
            entregue: 'Delivered',
            cancelled: 'Cancelled',
          },
        },

        profile: {
          eyebrow: 'User panel',
          backBtn: 'Back to Dashboard',
          title: 'My Account',
          subtitle: 'Manage your personal information',
          photoCard: 'Profile Photo',
          photoChange: 'Change photo',
          photoAdd: 'Add photo',
          photoUploading: 'Uploading...',
          photoHint: 'JPG, PNG or GIF. Maximum 5MB.',
          infoCard: 'Basic Information',
          fieldName: 'Full Name',
          fieldEmail: 'Email',
          fieldEmailHint: 'Email cannot be changed',
          fieldPhone: 'Phone / WhatsApp',
          fieldBirth: 'Date of Birth',
          fieldCpf: 'CPF',
          addressCard: 'Delivery Address',
          addressSubtitle: 'Used for physical plaque delivery',
          addressComplete: '✅ Complete',
          addressMissing: '⚠️ Not filled',
          addressSaveBtn: 'Save delivery address',
          addressSaved: 'Delivery address saved!',
          addressError: 'Error saving delivery address',
          saveBtn: 'Save Changes',
          saving: 'Saving...',
          toastSuccess: 'Profile updated successfully!',
          toastError: 'Error updating profile',
          toastPhotoSuccess: 'Photo updated successfully!',
          toastPhotoError: 'Error saving photo',
          toastLoadError: 'Error loading profile data',
          photoErrorType: 'Please select an image',
          photoErrorSize: 'Image must be at most 5MB',
          cepNotFound: 'ZIP code not found.',
          cepFetchError: 'Error fetching ZIP code. Please fill it manually.',
          validation: {
            recipient_name: 'Recipient name is required.',
            phone: 'Phone is required.',
            zip_code: 'ZIP code is required.',
            street: 'Street is required.',
            number: 'Number is required.',
            neighborhood: 'Neighborhood is required.',
            city: 'City is required.',
            state: 'State is required.',
          },
          addressForm: {
            sectionTitle: 'Enter where your plate should be delivered',
            recipientNameLabel: 'Recipient name *',
            recipientNamePlaceholder: 'Full name of the recipient',
            phoneLabel: 'Phone *',
            phonePlaceholder: '(00) 00000-0000',
            zipLabel: 'ZIP code *',
            zipPlaceholder: '00000-000',
            searchingCep: 'Searching...',
            streetLabel: 'Street / Address *',
            streetPlaceholder: 'Street name, avenue...',
            numberLabel: 'Number *',
            numberPlaceholder: '123',
            complementLabel: 'Complement',
            complementPlaceholder: 'Apt, block, suite... (optional)',
            neighborhoodLabel: 'Neighborhood *',
            neighborhoodPlaceholder: 'Neighborhood name',
            cityLabel: 'City *',
            cityPlaceholder: 'City name',
            stateLabel: 'State *',
            statePlaceholder: 'State',
            cancel: 'Cancel',
            saveAddressBtn: 'Save delivery address',
          },
        },
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt',
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;